import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import saveAs from 'file-saver';
import { JSEncrypt } from 'jsencrypt'
import aes from 'crypto-js/aes'
import { languageSwitchItem } from '../actions/locales'
import { cipher } from '../actions/stringEncodersFuncs'
import { createSession, sendInputData, sendDSData, sendSessionMetaData, sendSessionOption,
		    sendKeyContainer, createDS, getDSResult, deleteSession, sendTokenPath, getDSStatus, createMobileDS, getMobileDSData, getCreateMobileDSResult,
		    verifyDSData, getVerifiedData, getQR, createVtcoDs, premission2fVtco, premissionVtco, getVTokenMpo, createVTokenES, getVTokenPassResult, getVtcoProtectedParams } from '../actions/api'
import { setInputFileForDS, setInputDescription, clearInputFileForDS, clearInputDescription, clearFileList, clearFileListWithDS, setQRList, clearQRList,
			setDSData, clearDSData, setPrevisionDsFile, clearPrevisionDsFile, setDSEncodingType, setFilesForDS, setFilesWithDS, setCreateDSExpand, setCleanUpForm,
			setTmpPin, setTmpTwoFactorCode, setErrorData, setShowErrorPopup, setShowPreviewPopup,
			clearFileForPrivateSign, setFileForPrivateSign, setPngChecked, setQrChecked, setFileForPrivateSignPng, clearFileForPrivateSignPng, setFilesWithDSForPrivateSign,
			setImageForPrivateSign, setConvertedImage, setImageParamsSetted, setSignedDataForInputFile, setSignaturePageNumder, setSignaturePositionX,
			setSignaturePositionY, setSignatureSize, setQrAdvancedChecked, setQrTextData, setInputTypeFor2F, setImageFor2F, setProtectedParams } from '../actions/localStates'
import i18next from 'i18next'
import { bindActionCreators } from 'redux';

import { PDFDocument, rgb } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import robotoTTF from '../fonts/Roboto-Regular.ttf';

import CreateTextDSContainer from './CreateTextDSContainer'
import TwoFactorConfirmPopup from '../components/body/TwoFactorConfirmPopup'

import QRPopup from '../components/body/QRPopup'
import PinPopup from '../components/body/PinPopup'

import PDFPreviewer from '../components/body/PDFPreviewer'
import VTokenPassConfirmPopup from '../components/body/VTokenPassConfirmPopup'

import Dropzone from 'react-dropzone';
const dropzoneRef = createRef();
const dropzoneFileForPrivateSignRef = createRef();
const dropzoneFileForPrivateSignPngRef = createRef();

class CreateDSFilesContainer extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
			baseUrl: "https://local.cipher.kiev.ua:9090/api/v1/ticket/",
      		uuid: null,
      		isLoading: false,
      		fileForDSDescription: this.props.createDSDefaultState.fileForDSDescription,
      		blobData: null,
      		downloadIsAvailable: true,
      		files: this.props.createDSDefaultState.fileList || [],
      		filesWithDS: this.props.createDSDefaultState.filesWithDS || [],
      		qrForFiles: this.props.createDSDefaultState.qrList || [],
      		settedToken: null,
      		success: 0,
      		failed: 0,
      		sizeOfFiles: 0,
      		collapseCreateDSShow: "",
      		displayedData: null,
      		showPopup: false,
      		showPinPopup: false,
      		showVtcoConfirmPopup: false,
      		numberOfPinInput: 0,
			needToReEnterPin: false,
			successCreation: false,
			base64ToSend: null,
			signaturePositionX: 20,
            signaturePositionY: 120,
            signaturePageNumber: 1,
            showModal: false,
            textForQr: this.props.createDSDefaultState.qrTextData,
            qrTextData: null,
            modifyedPdfData: null,
            qrTextDataSetted: false,
            showVTokenPassConfirmPopup: false,
            base64ImgForVTokenPass: null,
            mpoTtlMillis: 0,
            codeTtl: 0
	    }

	    this.onChangeFile = this.onChangeFile.bind(this)
	    this.withToken = this.withToken.bind(this)
	    this.createMobileDS = this.createMobileDS.bind(this)
	    this.createQRData = this.createQRData.bind(this);
	    this.getQR = this.getQR.bind(this);

	    this.handleShowQR = this.handleShowQR.bind(this);

	    this.handleShowPin = this.handleShowPin.bind(this);
	    this.handleOnDrop = this.handleOnDrop.bind(this);

	    this.handleCreateDSUsingPin = this.handleCreateDSUsingPin.bind(this);

	    this.downloadZip = this.downloadZip.bind(this);
		this.checkPngHandler = this.checkPngHandler.bind(this)
		this.checkQrHandler = this.checkQrHandler.bind(this)

		this.checkQrAdvancedHandler = this.checkQrAdvancedHandler.bind(this)

		this.handleOnDropPrivateSign = this.handleOnDropPrivateSign.bind(this);
		this.handleOnDropPrivateSignPng = this.handleOnDropPrivateSignPng.bind(this);

		this.createQrForPrivateSign = this.createQrForPrivateSign.bind(this);

		this.getPrivateSign = this.getPrivateSign.bind(this);

		this.setImageData = this.setImageData.bind(this)

		this.generateQRForPrivateSign = this.generateQRForPrivateSign.bind(this)

		this.addToPDFWithFont = this.addToPDFWithFont.bind(this)

    	this.base64ToArrayBuffer = this.base64ToArrayBuffer.bind(this)

    	this.controller = null;
	}

	cancelRequest = () => {
        if (this.controller) {
            this.controller.abort();
            this.setState({isLoading: false})
            this.setState({showVTokenPassConfirmPopup: false})
            this.setState({showVtcoConfirmPopup: false})
        }
    }

	handleShow = () => {
	    this.setState({ showModal: true });
	};

	handleClose = () => {
		this.setState({ showModal: false });
	};

	onSignaturePositionXChanged (e) {
		function validateInput(input) {
		    return /^[0-9]+$/.test(input);
		}
 		
 		const value = e.target.value.trim();
	    if (validateInput(value)) {
	        this.setState({ "signaturePositionX": Number(value) });
	    } else if (value === "") {
	        this.setState({ "signaturePositionX": 0 });
	    }
	}

	onSignaturePositionYChanged (e) {
		function validateInput(input) {
		    return /^[0-9]+$/.test(input);
		}
 		
 		const value = e.target.value.trim();
	    if (validateInput(value)) {
	        this.setState({ "signaturePositionY": Number(value) });
	    } else if (value === "") {
	        this.setState({ "signaturePositionY": 0 });
	    }
	}

	onSignaturePageNumberChanged (e) {
		function validateInput(input) {
		    return /^[1-9][0-9]*$/.test(input);
		}
 		
 		const value = e.target.value.trim();
	    if (validateInput(value)) {
	        this.setState({ "signaturePageNumber": Number(value) });
	    } else if (value === "") {
	        this.setState({ "signaturePageNumber": 1 });
	    }
	}

	buildFileInputSelector(){
		const fileForPrivateSing = document.getElementById('fileForPrivateSingUpload');
		return fileForPrivateSing;
	}

    handleFileForPrivateSing(e) {
    	const fileForPrivateSing = document.getElementById('fileForPrivateSingUpload');
	    e.preventDefault();
	    fileForPrivateSing.value = null;
	    fileForPrivateSing.click()
	    document.activeElement.blur()
	}

	handleFileForPrivateSingPng(e) {
    	const fileForPrivateSingPng = document.getElementById('fileForPrivateSingPngUpload');
	    e.preventDefault();
	    fileForPrivateSingPng.value = null;
	    fileForPrivateSingPng.click()
	    document.activeElement.blur()
	}

	onChangeFileForPrivateSing(e) {
		var _this = this;
		if (e.target.files[0] !== undefined) {
			this.props.actions.setFileForPrivateSign(e.target.files[0])
			function readFile(file) {
			  return new Promise((resolve, reject) => {
			    const reader = new FileReader();

			    reader.onload = res => {
			    var base64String = window.btoa(res.target.result);
			    // names.push(file.name)
			      resolve(base64String);
			    };
			    reader.onerror = err => reject(err);

			    reader.readAsBinaryString(file);
			  });
			}

			async function read(file) {
				var b64string = await readFile(file);
				_this.props.actions.setSignedDataForInputFile(b64string)
			}

			read(e.target.files[0])
		}
	}

	onChangeFileForPrivateSingPng (e) {
		if (e.target.files[0] !== undefined) {
			this.props.actions.setFileForPrivateSignPng(e.target.files[0])
		}
	}

	cleanUpFileForPrivateSign () {
		this.props.actions.clearFileForPrivateSign()
	}

	cleanUpFileForPrivateSignPng () {
		this.props.actions.clearFileForPrivateSignPng()
		this.setState({"base64ToSend": null})
		this.props.actions.setConvertedImage(null)
	    this.props.actions.setImageForPrivateSign(null)
		this.props.actions.setImageParamsSetted(false);
	}

    checkPngHandler () {
    	var _this = this;
    	this.props.actions.setPngChecked(true)
    	this.props.actions.setQrChecked(false)
    	this.props.actions.setQrAdvancedChecked(false)
    	this.props.actions.setConvertedImage(null)
    	this.props.actions.setFilesWithDSForPrivateSign(null)
    	this.props.actions.setQrTextData(null)
    	this.setState({qrTextData: null})
        this.setState({modifyedPdfData: null})
        this.setState({qrTextDataSetted: false})

    	if (this.props.createDSDefaultState.fileForPrivateSignPng !== null) {
    		function imageUploaded(file) {
	            let reader = new FileReader();

	            reader.onload = function () {
	                var base64String = reader.result.replace("data:", "")
	                    .replace(/^.+,/, "");

	                var imageBase64Stringsep = base64String;
	                _this.props.actions.setConvertedImage(imageBase64Stringsep)
	                _this.props.actions.setImageForPrivateSign(_this.props.createDSDefaultState.fileForPrivateSignPng)
					_this.props.actions.setImageParamsSetted(false);
					var tempObj = {
						width: 50,
						height: 50
					}
					_this.props.actions.setSignaturePageNumder(1);
					_this.props.actions.setSignaturePositionX(20);
					_this.props.actions.setSignaturePositionY(20);
					_this.props.actions.setSignatureSize(tempObj)
	            }
	            reader.readAsDataURL(file);
	        }

	        imageUploaded(this.props.createDSDefaultState.fileForPrivateSignPng)
    	}
    }

	checkQrHandler () {
		this.props.actions.setPngChecked(false)
    	this.props.actions.setQrChecked(true)
    	this.props.actions.setQrAdvancedChecked(false)
    	this.props.actions.setConvertedImage(null)
    	this.props.actions.setImageParamsSetted(false);
    	this.props.actions.setFilesWithDSForPrivateSign(null)
    	this.props.actions.setQrTextData(null)
    	this.setState({qrTextData: null})
        this.setState({modifyedPdfData: null})
        this.setState({qrTextDataSetted: false})
    	var tempObj = {
			width: 50,
			height: 50
		}
		this.props.actions.setSignaturePageNumder(1);
		this.props.actions.setSignaturePositionX(20);
		this.props.actions.setSignaturePositionY(20);
		this.props.actions.setSignatureSize(tempObj)
    	this.generateQRForPrivateSign()
	}

	checkQrAdvancedHandler () {
		this.props.actions.setPngChecked(false)
    	this.props.actions.setQrChecked(false)
    	this.props.actions.setQrAdvancedChecked(true)
    	this.props.actions.setConvertedImage(null)
    	this.props.actions.setImageParamsSetted(false);
    	this.props.actions.setFilesWithDSForPrivateSign(null)
    	var tempObj = {
			width: 50,
			height: 50
		}
		this.props.actions.setSignaturePageNumder(1);
		this.props.actions.setSignaturePositionX(20);
		this.props.actions.setSignaturePositionY(20);
		this.props.actions.setSignatureSize(tempObj)
    	this.generateQRForPrivateSign()
	}

	expandCreateDS() {
		this.props.actions.setCreateDSExpand(this.props.expandedCardsReducer.createExpanded)
		this.props.expandedCardsReducer.createExpanded ? this.setState({collapseCreateDSShow: "card-body collapse"}) : this.setState({collapseCreateDSShow: "card-body collapse show"})
	}

	buildFilesMultipleInputSelector(){
		const filesMultipleInput = document.getElementById('filesMultipleUpload');
		return filesMultipleInput;
	}

	componentDidMount() {
		var dropFile = document.getElementById('dropFile');

		this.fileForPrivateSing = this.buildFileInputSelector();

		this.filesMultipleInput = this.buildFilesMultipleInputSelector();
		this.props.expandedCardsReducer.createExpanded ? this.setState({collapseCreateDSShow: "card-body collapse show"}) : this.setState({collapseCreateDSShow: "card-body collapse"})

		if (dropFile !== null) {
			dropFile.addEventListener('dragenter', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragover', function(event) {
				dropFile.style.border = "2px solid steelblue";
			}, false);

			dropFile.addEventListener('dragleave', function(event) {
				dropFile.style.border = "";
			}, false);

			dropFile.addEventListener('drop', function(event) {
				dropFile.style.border = "";
			}, false);
		}

		this.setState({"successCreation": false})
	}

	componentDidUpdate(prevProps) {
		if (prevProps.duplicateSign !== this.props.defaultState.duplicateSign) {
			this.filesMultipleInput = this.buildFilesMultipleInputSelector();
		}

		if (prevProps.defaultState !== this.props.defaultState) {
			this.setState({"successCreation" : false})
			this.setState({"base64ToSend": null})
		}
	}

	setFilesCount () {
		this.setState({files: this.props.createDSDefaultState.fileList})
	}

	downloadZip () {
		var _this = this, filename = "", fileWithoutExtension = ""
		const zip = require('jszip')();
		let files = this.props.createDSDefaultState.filesWithDS;
		for (let file = 0; file < this.props.createDSDefaultState.filesWithDS.length; file += 1) {
			var blob, extension = ".p7s", extensionType = {type : 'application/pkcs7-signature'};
			
			if (this.props.defaultState.asicForm !== "NONE") {
				if (this.props.defaultState.asicForm === "ASIC_S") {
					extension = ".asics"
					extensionType = {type : 'application/vnd.etsi.asic-s+zip'}
				} else {
					extension = ".asice"
					extensionType = {type : 'application/vnd.etsi.asic-e+zip'}
				}
			}

			if (this.props.defaultState.xadesType !== "NONE") {
				if (this.props.defaultState.asicForm !== "NONE" && this.props.defaultState.asicForm === "ASIC_E") {
					extension = ".asice"
					extensionType = {type : 'application/vnd.etsi.asic-e+zip'}
				} else {
					extension = ".xml"
					extensionType = {type : 'application/xml'}
				}
			};

			if (this.props.defaultState.padesType !== "NONE") {
				extension = "-" + this.props.defaultState.padesType + ".pdf"
				extensionType = {type : 'application/pdf'}
			}

	    	const b64toBlob = (b64Data, contentType, sliceSize = 512) => {
			  const byteCharacters = atob(b64Data);
			  const byteArrays = [];

			  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
			    const slice = byteCharacters.slice(offset, offset + sliceSize);

			    const byteNumbers = new Array(slice.length);
			    for (let i = 0; i < slice.length; i++) {
			      byteNumbers[i] = slice.charCodeAt(i);
			    }

			    const byteArray = new Uint8Array(byteNumbers);
			    byteArrays.push(byteArray);
			  }

			  const blob = new Blob(byteArrays, {type: contentType});
			  return blob;
			}

			var currDate = new Date();
			var dateWithOffset = new Date(currDate.getTime() - currDate.getTimezoneOffset() * 60000);
	    	if (_this.props.base.isVtco) {
	    		if (this.props.defaultState.padesType !== "NONE") {
		    		filename = this.props.createDSDefaultState.fileList[file].name
		    		fileWithoutExtension = filename.split('.').slice(0, -1).join('.')
		    	}
	    		blob = b64toBlob(files[file], extensionType);

	    		if (fileWithoutExtension.length > 0) {
	    			zip.file(fileWithoutExtension + extension, blob, {date: dateWithOffset});
	    		} else {
	    			zip.file(this.props.createDSDefaultState.fileList[file].name + extension, blob, {date: dateWithOffset});
	    		}
	    		
	    	} else {
	    		if (this.props.defaultState.padesType !== "NONE") {
		    		filename = this.props.createDSDefaultState.fileList[file].name
		    		fileWithoutExtension = filename.split('.').slice(0, -1).join('.')
		    	}

		    	if (fileWithoutExtension.length > 0) {
	    			zip.file(fileWithoutExtension + extension, files[file], {date: dateWithOffset});
	    		} else {
	    			zip.file(this.props.createDSDefaultState.fileList[file].name + extension, files[file], {date: dateWithOffset});
	    		}
	    	}

		}

		zip.generateAsync({type: "blob"}).then(content => {
			saveAs(content, "CaasZippedData.zip");
		});
	}

	handleShowQR (i) {
		var data;

		document.activeElement.blur();

		if (this.state.displayedData === null) {
			data = {
				fileName: this.props.createDSDefaultState.fileList[i].name,
				qrLink: this.state.qrForFiles[i]
			}

			this.setState({
	        	displayedData: data
	        })
		} else {
			this.setState({
	        	displayedData: null
	        })
		}

        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    handleShowPin () {
    	this.setState({
            showPinPopup: !this.state.showPinPopup
        });
    }

    handleCreateDSUsingPin () {
    	this.setState({showPinPopup: false})
    	this.createMultipleDS();
    }

    createMultipleDSWithSigns () {
    	if (this.props.pkLocalState.showPinInput) {
    		this.props.actions.setTmpPin("")
			this.props.actions.setTmpTwoFactorCode("")
    		this.handleShowPin()
    	} else {
    		this.createMultipleDS();
    	} 
    }

	handleFileInput(e) {
	    e.preventDefault();
	    this.filesMultipleInput.value = null;
	    this.filesMultipleInput.click()
	    document.activeElement.blur()
	}

	onChangeFile(e) {
		let fileList = this.state.files;
		let allFilesSize = this.state.sizeOfFiles;
		let showAlert = false;
		if (fileList.length === 0) {
			this.setState({"sizeOfFiles": 0})
			allFilesSize = 0;
		}
		if (e.target.files[0] !== undefined && e.target.files.length > 0) {
			
			if (allFilesSize < 104857600) {
				for (var i = 0; i < e.target.files.length; i += 1) {
					if (e.target.files[i].size === 0 || e.target.files[i].fileSize === 0) {
						alert(i18next.t("ds:zeroFileSize"))
						return;
					}
					if (allFilesSize + (e.target.files[i].size || e.target.files[i].fileSize) < 104857600) {
						fileList.push(e.target.files[i])
						allFilesSize += e.target.files[i].size
						this.setState({"sizeOfFiles": allFilesSize})
					} else {
						showAlert = true;
					}
				}
				this.setState({"files": fileList}, () => {
					this.props.actions.setFilesForDS(this.state.files);
					this.setState({"successCreation": false})
				})

				if (showAlert) {
					alert(i18next.t("maxFileSizeTitle"))
				}

			} else {
				alert(i18next.t("maxFileSizeTitle"))
			}
		}
	}

	handleOnDrop (files) {
		let fileList = this.state.files;
		let allFilesSize = this.state.sizeOfFiles;
		let showAlert = false;
		if (fileList.length === 0) {
			this.setState({"sizeOfFiles": 0})
			allFilesSize = 0;
		}
		if (files[0] !== undefined && files.length > 0) {
			
			if (allFilesSize < 104857600) {
				for (var i = 0; i < files.length; i += 1) {
					if (files[i].size === 0 || files[i].fileSize === 0) {
						alert(i18next.t("ds:zeroFileSize"))
						return;
					}
					if (allFilesSize + (files[i].size || files[i].fileSize) < 104857600) {
						fileList.push(files[i])
						allFilesSize += files[i].size
						this.setState({"sizeOfFiles": allFilesSize})
					} else {
						showAlert = true;
					}
				}
				this.setState({"files": fileList}, () => {
					this.props.actions.setFilesForDS(this.state.files);
					this.setState({"successCreation": false})
				})

				if (showAlert) {
					alert(i18next.t("maxFileSizeTitle"))
				}

			} else {
				alert(i18next.t("maxFileSizeTitle"))
			}
		}
	}

	handleOnDropPrivateSign (files) {
		var _this = this;
		if (files[0] !== undefined && files.length > 0) {
			this.props.actions.setFileForPrivateSign(files[0])

			function readFile(file) {
			  return new Promise((resolve, reject) => {
			    const reader = new FileReader();

			    reader.onload = res => {
			    var base64String = window.btoa(res.target.result);
			    // names.push(file.name)
			      resolve(base64String);
			    };
			    reader.onerror = err => reject(err);

			    reader.readAsBinaryString(file);
			  });
			}

			async function read(file) {
				var b64string = await readFile(file);
				_this.props.actions.setSignedDataForInputFile(b64string)
			}

			read(files[0])
		}
	}

	base64ToArrayBuffer = (base64) => {
	    const base64String = base64.includes(',') ? base64.split(',')[1] : base64;
	    const binaryString = atob(base64String);
	    const len = binaryString.length;
	    const bytes = new Uint8Array(len);
	    for (let i = 0; i < len; i++) {
	      bytes[i] = binaryString.charCodeAt(i);
	    }
	    return bytes.buffer;
	};


	addToPDFWithFont = async (qrText, base64Data, currentPage, imageX, imageY, imageWidth, imageHeight, scale) => {
		var _this = this;
	    const { PDFDocument, rgb } = await import('pdf-lib');

	    try {
	      const pdfBytes = this.base64ToArrayBuffer(base64Data);
	      const pdfDoc = await PDFDocument.load(pdfBytes);

	      pdfDoc.registerFontkit(fontkit);

	      const pages = pdfDoc.getPages();
	      if (!pages || pages.length === 0) {
	        console.error("PDF не містить сторінок або некоректний формат");
	        return;
	      }

	      if (currentPage < 1 || currentPage > pages.length) {
	        console.error('Сторінка PDF недоступна:', currentPage, pages.length);
	        return;
	      }

	      const page = pages[currentPage - 1];
	      const { height: pdfPageHeight } = page.getSize();

	      const fontBytes = await fetch(robotoTTF).then(res => res.arrayBuffer());
	      const customFont = await pdfDoc.embedFont(fontBytes);

	      // const imageBytes = await imageFile.arrayBuffer();
	      // const pdfImage = await pdfDoc.embedPng(imageBytes);

	      const x = imageX / scale;
	      const y = pdfPageHeight - (imageY / scale) - imageHeight / scale - 20;

	      // page.drawImage(pdfImage, {
	      //   x,
	      //   y,
	      //   width: imageWidth / scale,
	      //   height: imageHeight / scale,
	      // });

	    if (qrText) {
			const fontSize = 10;
			const lines = qrText.split(/\r?\n/);
			let textX = x + imageWidth / scale + 10;
			let textY = y + imageHeight / scale + 8;

			for (const line of lines) {
				page.drawText(line, {
				  x: textX,
				  y: textY,
				  size: fontSize,
				  font: customFont,
				  color: rgb(0, 0, 0),
				});
				textY -= fontSize * 1.3;
			}
		}

	      const newPdfBytes = await pdfDoc.save();
	      const blob = new Blob([newPdfBytes], { type: 'application/pdf' });
	      const file = new File([blob], 'signed.pdf', { type: 'application/pdf' });
	      _this.setState({modifyedPdfData: file})
	      _this.setState({qrTextDataSetted: true})
	      _this.createMultipleDS()

	 //    function fileToBase64(file, callback) {
		//     const reader = new FileReader();
		//     reader.onloadend = () => callback(reader.result);
		//     reader.readAsDataURL(file);
		// }

		// fileToBase64(file, (base64String) => {
  //           console.log(base64String);
  //           _this.setState({modifyedPdfData: base64String})
  //           _this.setState({qrTextData: null})
  //           // _this.setState({modifyedPdfData: null})
  //           _this.createMultipleDS()
  //       });

	      // const link = document.createElement('a');
	      // link.href = URL.createObjectURL(file);
	      // link.download = file.name;
	      // link.click();
	      // URL.revokeObjectURL(link.href);

	      console.log('PDF з QR та текстом збережений!', file);

	    } catch (err) {
	      console.error('Помилка при вставці QR у PDF:', err);
	    }
	};

	setImageData (input) {
		var _this = this

		function isEmpty(obj) {
		  for (const prop in obj) {
		    if (Object.hasOwn(obj, prop)) {
		      return false;
		    }
		  }

		  return true;
		}

		function imageUploaded(file) {

            let reader = new FileReader();

            reader.onload = function () {
                var base64String = reader.result.replace("data:", "")
                    .replace(/^.+,/, "");

                var imageBase64Stringsep = base64String;
                _this.props.actions.setConvertedImage(imageBase64Stringsep)
                _this.props.actions.setSignaturePageNumder(input.coords.page);
                _this.props.actions.setSignaturePositionX(Math.round(input.coords.x));
				_this.props.actions.setSignaturePositionY(Math.round(input.coords.y));
				_this.props.actions.setSignatureSize(input.coords);
				_this.props.actions.setImageParamsSetted(true);
				if (_this.props.createDSDefaultState.qrAdvancedChecked && !isEmpty(input.textData)) {
					_this.props.actions.setQrTextData(input.textData.qrText)
					_this.setState({qrTextData: input.textData})
					_this.setState({qrTextDataSetted: false})
					console.log(input.textData)
				}
				_this.setState({ showModal: false });
            }

            // if (_this.props.createDSDefaultState.qrAdvancedChecked === true && _this.state.textForQr !== null) {
            // 	_this.props.actions.setImageForPrivateSign(file)
            // 	_this.setState({textForQr: null})
            // }

            reader.readAsDataURL(file);
        }

        imageUploaded(input.file)
	}

	handleOnDropPrivateSignPng (files) {
		var savedPngFile = null, _this = this;
		if (files[0] !== undefined && files.length > 0) {
			this.props.actions.setFileForPrivateSignPng(files[0])

			function imageUploaded(file) {

	            let reader = new FileReader();

	            reader.onload = function () {
	                var base64String = reader.result.replace("data:", "")
	                    .replace(/^.+,/, "");

	                var imageBase64Stringsep = base64String;
	                _this.props.actions.setConvertedImage(imageBase64Stringsep)
					_this.props.actions.setImageParamsSetted(false);
	            }

	            reader.readAsDataURL(file);
	        }

	        imageUploaded(files[0])
		}

		const reader = new FileReader();
		reader.onload = function(e) {
			const img = new Image();
			img.onload = function() {
				  const canvas = document.createElement('canvas');
				  canvas.width = img.width;
				  canvas.height = img.height;
				  const ctx = canvas.getContext('2d');
				  ctx.drawImage(img, 0, 0);

				  canvas.toBlob(function(blob) {
				    savedPngFile = new File([blob], files[0].name + '.png', { type: 'image/png' });
				    console.log('Файл PNG збережено у пам’яті:', savedPngFile);
				    _this.props.actions.setImageForPrivateSign(savedPngFile)
				  }, 'image/png');
				};
				img.src = e.target.result;
			};
		reader.readAsDataURL(files[0]);
	}

	deleteItem(id) {
		const files = this.state.files
		const filesWithDS = this.state.filesWithDS
		const qrForFiles = this.state.qrForFiles
		var allFilesSize = this.state.sizeOfFiles

		allFilesSize = allFilesSize - files[id].size
		this.setState({"sizeOfFiles": allFilesSize})

		files.splice(id, 1)
		filesWithDS.splice(id, 1)
		qrForFiles.splice(id, 1)


		this.setState({"files": files}, () => {
			this.props.actions.setFilesForDS(this.state.files);
		})
		this.setState({"filesWithDS": filesWithDS}, () => {
			this.props.actions.setFilesWithDS(this.state.filesWithDS);
		})
		this.setState({"success": 0})
		this.setState({"qrForFiles": qrForFiles})
		this.setState({"successCreation": false})
	}

	onChangePrevisionDsFile(e) {
		if (e.target.files[0] !== undefined && (e.target.files[0].size < 104857600)) {
			this.props.actions.setPrevisionDsFile(e.target.files[0])
			this.props.actions.clearDSData()
		}
	}

	formatDate(dateInString) {
        var localeDateOptions = {
            "day": "numeric",
            "month": "numeric",
            "year": "numeric",
            "hour": "2-digit",
            "minute": "2-digit",
            "second": "2-digit"
        }

        return new Date(dateInString).toLocaleDateString(i18next.language, localeDateOptions);
    }

    constructTimestampDetails(aTs, aTsType, forQR) {
        let contentTs = i18next.t("dataTs");
        let signatureTs = i18next.t("dsTs");
        let tsaDS = i18next.t("tsaCertificateSerialNumberDS");
        let tsa = i18next.t("tsaCertificateSerialNumber");
        let result = [];

        let tsTypeString = function () {
            if (aTsType === "content") {
                return contentTs;
            }
            if (aTsType === "signature") {
                return signatureTs;
            }
            return "";
        }

        let tsaTsTypeString = function () {
            if (aTsType === "content") {
                return tsa;
            }
            if (aTsType === "signature") {
                return tsaDS;
            }
            return "";
        }
        
        if (forQR) {
        	var str = ""
        	if (aTs && aTs.dateTime) {
	            if (aTs.isFailure) {
	                result.push(tsTypeString() + i18next.t("ds:errorWhileVerifying"));
	            } else {
	            	str += aTs.tsaCertificateSerialNumber ? tsaTsTypeString() + aTs.tsaCertificateSerialNumber + "\n" : "";

		            str += tsTypeString() + ": " + (aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid")) + "; " + this.formatDate(aTs.dateTime)

	            	result.push(str);
	            }
	        }

	        return result
        } else {
        	if (aTs && aTs.dateTime) {
	            if (aTs.isFailure) {
	                result.push(<div>{tsTypeString() + i18next.t("ds:errorWhileVerifying")}</div>);
	            } else {
	            	result.push(
	            		aTs.tsaCertificateSerialNumber
	            		? <div><span className="font-weight-bold">{tsaTsTypeString()}</span>
		                	{
			            		aTs.tsaCertificateSerialNumber
		                	}
		                </div>
		                : <div><span className="font-weight-bold">{tsTypeString()}</span>
	            			{
			            		": "
			                    + (aTs.isValid ? i18next.t("ds:sheIsValid") : i18next.t("ds:sheIsInvalid"))
			                    + "; "
			                    + this.formatDate(aTs.dateTime)
		                	}
		                </div>
	                );
	            }
	        }
	        return result;
        }
    }

	async getQR (data) {
    	var _this = this, result;
		result = await _this.props.actions.getQR(_this.props.base.qrCodeUrl, data, _this.props.base.token)
		var objectURL = URL.createObjectURL(result);
		return objectURL;
	}

	createQRData (verifyResults, index) {
		var _this = this;

		if (!this.props.defaultState.generateQR) {
			return;
		}
		
		var str = "", tempData;

		async function processArray(array) {
			var qrFiles = _this.state.qrForFiles
			for (const item of array) {

				str += i18next.t("fileName") + _this.props.createDSDefaultState.fileList[index].name + "\n";
				str += (item.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && item.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") + "\n" : i18next.t("ds:unqualifiedTitle") + "\n"

				if (item.signerInfo.ownerCertificateInfo) {
					if (item.signerInfo.ownerCertificateInfo.value.ownerFullName.value) {
						str += i18next.t("ds:signer") + item.signerInfo.ownerCertificateInfo.value.ownerFullName.value + "\n";
					}

					if (item.signerInfo.ownerCertificateInfo.value.ownerPosition.value) {
						str += i18next.t("position") + item.signerInfo.ownerCertificateInfo.value.ownerPosition.value + "\n"
					}

					if (item.signerInfo.ownerCertificateInfo.value.ownerOrganization.value) {
						str += i18next.t("organization") + item.signerInfo.ownerCertificateInfo.value.ownerOrganization.value + "\n"
					}

					if (item.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value) {
						str += i18next.t("ds:drfou") + item.signerInfo.extensionsCertificateInfo.value.personalData.value.drfou.value + "\n"
					}

					if (item.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value) {
						str += i18next.t("ds:edrpou") + item.signerInfo.extensionsCertificateInfo.value.personalData.value.edrpou.value + "\n"
					}
					
					if (item.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value) {
						str += i18next.t("ds:eddrun") + item.signerInfo.extensionsCertificateInfo.value.personalData.value.eddrun.value + "\n"
					}

					if (item.signerInfo.issuerCertificateInfo.issuerOrganization) {
						str += i18next.t("issuerOrganization") + item.signerInfo.issuerCertificateInfo.issuerOrganization + "\n"
					}
					
					if (item.signerInfo.certificateSerialNumber.value) {
						str += i18next.t("certificateSerialNumberTitle") + item.signerInfo.certificateSerialNumber.value.replace(/\s/g, "") + "\n"
					}

					str += i18next.t("ds:ca") + item.signerInfo.issuerCertificateInfo.value.issuerFullName.value + "\n"
				}
			    
		    	if (item.signingDateTime !== undefined && item.signingDateTime.length > 0) {
			    	str += i18next.t("ds:dsDate") + _this.formatDate(item.signingDateTime) + "\n"
			    }
			    
			    if (item.contentTimestamp !== undefined) {
			    	str += _this.constructTimestampDetails(item.contentTimestamp, "content", true) + "\n"
			    }

		    	if (item.signatureTimestamps && item.signatureTimestamps.length) {
					for (var j = 0; j < item.signatureTimestamps.length; j += 1) {
						str += _this.constructTimestampDetails(item.signatureTimestamps[j], "signature", true) + "\n"
					}
				}

				if (item.signerInfo.extensionsCertificateInfo.value.isQualified.value.length > 0) {
					var qualifiedCertTitle = item.signerInfo.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:qualifiedCertTitle") + qualifiedCertTitle + "\n"
				}

				if (item.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value.length > 0) {
					var QSCDTitle = item.signerInfo.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
					str += i18next.t("ds:QSCDTitle") + QSCDTitle + "\n"
				}

				if (item.signerInfo.extensionsCertificateInfo.value.qscdTypeName) {
					var QSCDTypeTitle = item.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : item.signerInfo.extensionsCertificateInfo.value.qscdTypeName.value
					str += i18next.t("ds:QSCDTypeTitle") + QSCDTypeTitle + "\n"
				}

				if (item.signatureType) {
            		var signatureType = item.signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + item.signatureType)
            		str += i18next.t("ds:signatureType") + signatureType + "\n"
            	}

            	if (item.signatureFormat) {
            		var signatureFormat = item.signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + item.signatureFormat)
	            	str += i18next.t("ds:signatureFormat") + signatureFormat + "\n"
            	}

				console.log(str)


				tempData = await _this.getQR(str);
				
    			qrFiles.push(tempData)
    			_this.setState(function(){
				    return {"qrForFiles": qrFiles}
				});

				str = "";
			}
		}

		processArray(verifyResults)	
	}

	generateQRForPrivateSign () {
		var item = this.props.certInfoSignature, str = "", strForQR = "Сформовано засобами ТОВ \"САЙФЕР ПРО\"" + "\n" + "\n", _this = this, base64ToSend = "";
		this.setState({"failed": 0})
		this.setState({"filesWithDS": []})
		this.props.actions.setFilesWithDSForPrivateSign(null)

		async function createQRDataForPrivateSign (item) {
			if (_this.props.base.isVtco) {
				str += (item.extensions.isPrivateKeyOnQSCD === "true" && item.extensions.isQualified === "true") ? i18next.t("ds:qualifiedTitle") + "\n" : i18next.t("ds:unqualifiedTitle") + "\n"
			} else {
				str += (item.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" && item.extensionsCertificateInfo.value.isQualified.value === "true") ? i18next.t("ds:qualifiedTitle") + "\n" : i18next.t("ds:unqualifiedTitle") + "\n"
			}

			if (item.ownerCertificateInfo && !_this.props.base.isVtco) {
				if (item.ownerCertificateInfo.value.ownerFullName.value) {
					str += i18next.t("ds:signer") + item.ownerCertificateInfo.value.ownerFullName.value + "\n";
					strForQR += i18next.t("ds:signer") + "\n";
					strForQR += item.ownerCertificateInfo.value.ownerFullName.value + "\n"
				}

				if (item.ownerCertificateInfo.value.ownerPosition.value) {
					str += i18next.t("position") + item.ownerCertificateInfo.value.ownerPosition.value + "\n"
				}

				if (item.ownerCertificateInfo.value.ownerOrganization.value) {
					str += i18next.t("organization") + item.ownerCertificateInfo.value.ownerOrganization.value + "\n"
				}

				if (item.extensionsCertificateInfo.value.personalData.value.drfou.value) {
					str += i18next.t("ds:drfou") + item.extensionsCertificateInfo.value.personalData.value.drfou.value + "\n"
				}

				if (item.extensionsCertificateInfo.value.personalData.value.edrpou.value) {
					str += i18next.t("ds:edrpou") + item.extensionsCertificateInfo.value.personalData.value.edrpou.value + "\n"
				}
				
				if (item.extensionsCertificateInfo.value.personalData.value.eddrun.value) {
					str += i18next.t("ds:eddrun") + item.extensionsCertificateInfo.value.personalData.value.eddrun.value + "\n"
				}

				if (item.issuerCertificateInfo.issuerOrganization) {
					str += i18next.t("issuerOrganization") + item.issuerCertificateInfo.issuerOrganization + "\n"
				}
				
				if (item.certificateSerialNumber.value) {
					str += i18next.t("certificateSerialNumberTitle") + item.certificateSerialNumber.value.replace(/\s/g, "") + "\n"
					strForQR += i18next.t("certificateSerialNumberTitle") + "\n" + item.certificateSerialNumber.value.replace(/\s/g, "") + "\n"
				}

				if (item.notAfter && item.notBefore) {
					strForQR += i18next.t("notBeforeForQr") + "\n" + i18next.t("separator") + _this.formatDate(item.notBefore.value) + i18next.t("notAfterForQr") + _this.formatDate(item.notAfter.value)
				}

				str += i18next.t("ds:ca") + item.issuerCertificateInfo.value.issuerFullName.value + "\n"
			} else {
				if (item.subject.commonName) {
					str += i18next.t("ds:signer") + item.subject.commonName + "\n";
					strForQR += i18next.t("ds:signer") + "\n";
					strForQR += item.subject.commonName + "\n"
				}

				if (item.subject.title) {
					str += i18next.t("position") + item.subject.title + "\n"
				}

				if (item.subject.organisationName) {
					str += i18next.t("organization") + item.subject.organisationName + "\n"
				}

				if (item.extensions.drfou) {
					str += i18next.t("ds:drfou") + item.extensions.drfou + "\n"
				}

				if (item.extensions.edrpou) {
					str += i18next.t("ds:edrpou") + item.extensions.edrpou + "\n"
				}
				
				if (item.extensions.eddrun) {
					str += i18next.t("ds:eddrun") + item.extensions.eddrun + "\n"
				}

				if (item.issuer.organisationName) {
					str += i18next.t("issuerOrganization") + item.issuer.organisationName + "\n"
				}
				
				if (item.serialNumber) {
					str += i18next.t("certificateSerialNumberTitle") + item.serialNumber.replace(/\s/g, "") + "\n"
					strForQR += i18next.t("certificateSerialNumberTitle") + "\n" + item.serialNumber.replace(/\s/g, "") + "\n"
				}

				if (item.notAfter && item.notBefore) {
					strForQR += i18next.t("notBeforeForQr") + "\n" + i18next.t("separator") + _this.formatDate(item.notBefore) + i18next.t("notAfterForQr") + _this.formatDate(item.notAfter)
				}
			}

		    
	    	if (item.signingDateTime !== undefined && item.signingDateTime.length > 0) {
		    	str += i18next.t("ds:dsDate") + _this.formatDate(item.signingDateTime) + "\n"
		    }
		    
		    if (item.contentTimestamp !== undefined) {
		    	str += _this.constructTimestampDetails(item.contentTimestamp, "content", true) + "\n"
		    }

	    	if (item.signatureTimestamps && item.signatureTimestamps.length) {
				for (var j = 0; j < item.signatureTimestamps.length; j += 1) {
					str += _this.constructTimestampDetails(item.signatureTimestamps[j], "signature", true) + "\n"
				}
			}

			if (!_this.props.base.isVtco && item.extensionsCertificateInfo.value.isQualified.value.length > 0) {
				var qualifiedCertTitle = item.extensionsCertificateInfo.value.isQualified.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
				str += i18next.t("ds:qualifiedCertTitle") + qualifiedCertTitle + "\n"
			} else {
				var qualifiedCertTitle = item.extensions.isQualified === true ? i18next.t("yesUCase") : i18next.t("noUCase")
				str += i18next.t("ds:qualifiedCertTitle") + qualifiedCertTitle + "\n"
			}

			if (!_this.props.base.isVtco && item.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value.length > 0) {
				var QSCDTitle = item.extensionsCertificateInfo.value.isPrivateKeyOnQSCD.value === "true" ? i18next.t("yesUCase") : i18next.t("noUCase")
				str += i18next.t("ds:QSCDTitle") + QSCDTitle + "\n"
			} else {
				var QSCDTitle = item.extensions.isPrivateKeyOnQSCD === true ? i18next.t("yesUCase") : i18next.t("noUCase")
				str += i18next.t("ds:QSCDTitle") + QSCDTitle + "\n"
			}

			if (!_this.props.base.isVtco && item.extensionsCertificateInfo.value.qscdTypeName) {
				var QSCDTypeTitle = item.extensionsCertificateInfo.value.qscdTypeName.value === null ? i18next.t("ds:notDefined") : item.extensionsCertificateInfo.value.qscdTypeName.value
				str += i18next.t("ds:QSCDTypeTitle") + QSCDTypeTitle + "\n"
			} else {
				var QSCDTypeTitle = item.extensions.qscdTypeName === null ? i18next.t("ds:notDefined") : item.extensions.qscdTypeName
				str += i18next.t("ds:QSCDTypeTitle") + QSCDTypeTitle + "\n"
			}

			if (item.signatureType) {
	    		var signatureType = item.signatureType === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + item.signatureType)
	    		str += i18next.t("ds:signatureType") + signatureType + "\n"
	    	}

	    	if (item.signatureFormat) {
	    		var signatureFormat = item.signatureFormat === null ? i18next.t("ds:notDefined") : i18next.t("ds:" + item.signatureFormat)
	        	str += i18next.t("ds:signatureFormat") + signatureFormat + "\n"
	    	}

	    	_this.setState({textForQr: strForQR})
	    	_this.props.actions.setQrTextData(strForQR)

			var tempData = await _this.getQR(str);

			function objectURLToBase64(objectURL, callback) {
			    fetch(objectURL)
			        .then(response => response.blob())
			        .then(blob => {
			            const reader = new FileReader();
			            reader.onloadend = () => callback(reader.result);
			            reader.readAsDataURL(blob);
			        })
			        .catch(error => console.error("Помилка конвертації в Base64:", error));
			}

			objectURLToBase64(tempData, function(base64String) {
			    console.log(base64String);
			    const cleanBase64 = removeBase64Prefix(base64String);

			    function base64ToFile(base64String, filename = 'image.png') {
				  const base64Data = base64String.replace(/^data:image\/png;base64,/, '');
				  const byteCharacters = atob(base64Data);
				  const byteNumbers = new Array(byteCharacters.length);

				  for (let i = 0; i < byteCharacters.length; i++) {
				    byteNumbers[i] = byteCharacters.charCodeAt(i);
				  }

				  const byteArray = new Uint8Array(byteNumbers);
				  const blob = new Blob([byteArray], { type: 'image/png' });
				  const file = new File([blob], filename, { type: 'image/png' });

				  return file;
				}

				var newFile = base64ToFile(base64String)

				_this.props.actions.setImageForPrivateSign(newFile)
			    _this.props.actions.setConvertedImage(cleanBase64)
			    _this.setState({"base64ToSend": cleanBase64});
			});

			str = "";
		}

		function removeBase64Prefix(base64String) {
		    return base64String.replace(/^data:image\/png;base64,/, "");
		}

		createQRDataForPrivateSign(item)
	}

	createQrForPrivateSign () {
		var item = this.props.certInfoSignature, str = "", _this = this, base64ToSend = "";
		this.setState({"failed": 0})
		this.setState({"filesWithDS": []})
		this.props.actions.setFilesWithDSForPrivateSign(null)

		function removeBase64Prefix(base64String) {
		    return base64String.replace(/^data:image\/png;base64,/, "");
		}

		function fileToBase64(file, callback) {
		    const reader = new FileReader();
		    reader.onloadend = () => callback(reader.result);
		    reader.readAsDataURL(file);
		}

		if (this.props.createDSDefaultState.qrChecked) {
			_this.createMultipleDS()
		} else {
			fileToBase64(this.props.createDSDefaultState.imageForPrivateSign, (base64String) => {
	            console.log(base64String);
	            const cleanBase64 = removeBase64Prefix(base64String);
	            _this.props.actions.setFilesWithDSForPrivateSign(null)
	            _this.setState({"base64ToSend": cleanBase64});
	            _this.createMultipleDS()
	        });
		}		
	}

	async verifyFiles(file, index) {
		var _this = this, url;
		if (!_this.props.createDSDefaultState.active) {
			return
		}

		if (!_this.props.defaultState.generateQR) {
			return
		}

		if (this.props.pkLocalState.useUccConnection) {
			url = this.props.base.urlUCC + "/api/v1"
		} else {
			url = this.props.base.urlCloud + "/api/v1"
		}

		if (this.props.defaultState.signatureType !== "attached") {
			await this.props.actions.sendInputData(url, this.state.uuid, this.props.createDSDefaultState.fileList[index], _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		}
    	
    	await this.props.actions.sendDSData(url, this.state.uuid, file, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		await this.props.actions.sendSessionOption(url, this.state.uuid, this.props.verifyDefaultState, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		await this.props.actions.verifyDSData(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		await this.props.actions.getVerifiedData(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		.then(async (response) => {
			await this.createQRData(response.verifyResults, index, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		})
		.then(() => {
			console.log(_this.state.qrForFiles);
		})
	}

	async sendFiles(file) {
		var _this = this, url, metadata, padesCreationParameters = null;
		if (!_this.props.createDSDefaultState.active) {
			return
		}

		if (this.props.pkLocalState.useUccConnection) {
			url = this.props.base.urlUCC + "/api/v1"
		} else {
			url = this.props.base.urlCloud + "/api/v1"
		}

		if (this.state.base64ToSend !== null) {
			padesCreationParameters = {
	            "signaturePositionX": _this.props.createDSDefaultState.signaturePositionX,
	            "signaturePositionY": _this.props.createDSDefaultState.signaturePositionY,
	            "signaturePageNumber": _this.props.createDSDefaultState.signaturePageNumber,
	            "signatureImageData": _this.props.createDSDefaultState.convertedImage,
	            "signatureImageHeight": _this.props.createDSDefaultState.qrAdvancedChecked ? 87 : _this.props.createDSDefaultState.signatureImageHeight,
				"signatureImageWidth": _this.props.createDSDefaultState.qrAdvancedChecked ? 293 : _this.props.createDSDefaultState.signatureImageWidth
		    }
		} else {
			metadata = file.name
		}

    	await this.props.actions.sendInputData(url, this.state.uuid, file, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		await this.props.actions.sendSessionMetaData(url, this.state.uuid, padesCreationParameters !== null ? padesCreationParameters : metadata, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		await this.props.actions.sendSessionOption(url, this.state.uuid, this.props.defaultState, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        await this.props.actions.sendKeyContainer(url, this.state.uuid, this.props.pkLocalState.keyContainer, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        await this.props.actions.createDS(url, this.state.uuid, this.props.pkLocalState.keyContainerPassword, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        await this.props.actions.getDSResult(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        .then((response) => {
    		if (response !== null) {
    			var dsFiles = this.state.filesWithDS
				var success = this.state.success + 1
    			dsFiles.push(response)
    			this.setState({"success": success})
    			this.setState(function(){
				    return {"filesWithDS": dsFiles}
				});
    		}
        })
        await this.props.actions.getDSStatus(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        .then((response) => {
        	console.log(response)
        	if (response.failureCause !== undefined) {
        		var dsFiles = this.state.filesWithDS
	        	var failed = this.state.failed + 1
				this.setState({"failed": failed})
				dsFiles.push(response)
				this.setState(function(){
				    return {"filesWithDS": dsFiles}
				});
        	}
        })
	}

	async sendFilesWithToken(file) {
		var _this = this, url, metadata = {}, padesCreationParameters = null;
		if (!_this.props.createDSDefaultState.active) {
			return
		}

		if (this.props.pkLocalState.useUccConnection) {
			url = this.props.base.urlUCC + "/api/v1"
		} else {
			url = this.props.base.urlCloud + "/api/v1"
		}

		if (this.state.base64ToSend !== null) {
			padesCreationParameters = {
	            "signaturePositionX": _this.props.createDSDefaultState.signaturePositionX,
	            "signaturePositionY": _this.props.createDSDefaultState.signaturePositionY,
	            "signaturePageNumber": _this.props.createDSDefaultState.signaturePageNumber,
	            "signatureImageData": _this.props.createDSDefaultState.convertedImage,
	            "signatureImageHeight": _this.props.createDSDefaultState.qrAdvancedChecked ? 87 : _this.props.createDSDefaultState.signatureImageHeight,
				"signatureImageWidth": _this.props.createDSDefaultState.qrAdvancedChecked ? 293 : _this.props.createDSDefaultState.signatureImageWidth
		    }
		} else {
			metadata = file.name
		}

		var keyContainerPassword
	    if (this.props.pkLocalState.depositsignSelectedKey !== null) {
	        const publicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCDAChZGnfpj1SsGLIPCaHaL7ybqpMgvphowUroGp7WZ3XA7O3ucaHfIxQFOMNAKUooIkebpp+tLO6imROzxVTmZfySpNNdfBx3E3BU9VzXCBBEKyCrmNxH3AWwuQeoi1Z1ZZLFDI02AjQYR8Nd7TutDGS7FuYlMmIKHYW2+NGHSQIDAQAB";

	        const jsEncrypt = new JSEncrypt();
	        jsEncrypt.setPublicKey(publicKey);

	        if (this.props.pkLocalState.useTwoFactorCode) {
	            keyContainerPassword = aes.encrypt(this.props.pkLocalState.tmpPin, this.props.pkLocalState.tmpTwoFactorCode).toString();
	        } else { 
	            keyContainerPassword = jsEncrypt.encrypt(this.props.pkLocalState.tmpPin);
	        }
	    } else {
	        keyContainerPassword = this.props.pkLocalState.keyContainerPassword
	    }

    	await this.props.actions.sendInputData(url, this.state.uuid, file, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		await this.props.actions.sendSessionMetaData(url, this.state.uuid, padesCreationParameters !== null ? padesCreationParameters : metadata, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		await this.props.actions.sendSessionOption(url, this.state.uuid, this.props.defaultState, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        await this.props.actions.sendTokenPath(url, this.state.uuid, this.state.settedToken, this.props.pkLocalState.depositsignKeysInfo !== null ? this.props.pkLocalState.depositsignKeysInfo.Token : null, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        await this.props.actions.createDS(url, this.state.uuid, keyContainerPassword, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        await this.props.actions.getDSResult(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        .then((response) => {
    		if (response !== null) {
    			var dsFiles = this.state.filesWithDS
				var success = this.state.success + 1
    			dsFiles.push(response)
    			this.setState({"success": success})
    			this.setState(function(){
				    return {"filesWithDS": dsFiles}
				});
    		}
        })
        await this.props.actions.getDSStatus(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
        .then((response) => {
        	console.log(response)
        	if (response.failureCause !== undefined) {
        		var dsFiles = this.state.filesWithDS
	        	var failed = this.state.failed + 1
				this.setState({"failed": failed})
				dsFiles.push(response)
				this.setState(function(){
				    return {"filesWithDS": dsFiles}
				});
        	}
        })
	}

	async sendFilesMobileDS (file) {
		var _this = this;
		var profileData = {
    		number: this.props.pkLocalState.fullPhoneNumber,
    		position: this.props.pkLocalState.positionId,
    		service:  this.props.pkLocalState.serviceId
    	}
		if (!_this.props.createDSDefaultState.active) {
			return
		}
    	await this.props.actions.sendInputData(this.props.base.cloudURLForMobileDS, this.state.uuid, file, this.props.base.token)
		await this.props.actions.sendSessionOption(this.props.base.cloudURLForMobileDS, this.state.uuid, this.props.defaultState, this.props.base.token)
        await this.props.actions.createMobileDS(this.props.base.cloudURLForMobileDS, this.state.uuid, this.props.pkLocalState.msspId, profileData, this.props.base.token)
        await this.props.actions.getMobileDSData(this.props.base.cloudURLForMobileDS, this.state.uuid, this.props.pkLocalState.msspId, this.props.base.token)
        .then((response) => {
    		if (response !== null) {
    			var dsFiles = this.state.filesWithDS
				var success = this.state.success + 1
    			dsFiles.push(response)
    			this.setState({"success": success})
    			this.setState(function(){
				    return {"filesWithDS": dsFiles}
				});
    		}
        })
        await this.props.actions.getCreateMobileDSResult(this.props.base.cloudURLForMobileDS, this.state.uuid, this.props.pkLocalState.msspId, this.props.base.token)
        .then((response) => {
        	console.log(response)
        	if (response.failureCause !== undefined) {
        		var dsFiles = this.state.filesWithDS
	        	var failed = this.state.failed + 1
				this.setState({"failed": failed})
				dsFiles.push(response)
				this.setState(function(){
				    return {"filesWithDS": dsFiles}
				});
        	}
        })
	}

	showError(id) {
		var errorMessage = {
          message: this.state.filesWithDS[id].message,
          techMessage: this.state.filesWithDS[id].failureCause || this.state.filesWithDS[id].techMessage
        }
        this.props.actions.setErrorData(errorMessage)
        this.props.actions.setShowErrorPopup(true)

		// alert(this.state.filesWithDS[id].failureCause)
	}

	setBlobData(data) {
      this.setState({blobData:data});
    }

    clearBlobData() {
      this.setState({blobData:null});
    }

    cleanUpFileForDSInput() {
    	this.props.actions.clearQRList()
    	this.props.actions.clearInputFileForDS()
    	this.props.actions.clearDSData()
	}

	cleanUpPrevisionDsInput() {
    	this.props.actions.clearPrevisionDsFile()
    	this.props.actions.clearDSData()
	}

	cleanUpForm() {

		var tempObj = {
			width: 50,
			height: 50
		}

		this.props.actions.setCleanUpForm(false)
		this.props.actions.clearQRList()
		this.setState({"qrForFiles": []})
		this.setState({"filesWithDS": []})
		this.setState({"files": []})
		this.setState({"displayedData": null})
		this.setState({"successCreation": false})
		this.setState({"success": 0})
		this.props.actions.clearFileList()
		this.props.actions.clearFileListWithDS()
		this.props.actions.clearFileForPrivateSign()
		this.props.actions.setPngChecked(true)
		this.props.actions.setQrChecked(false)
		this.props.actions.setQrAdvancedChecked(false)
		this.props.actions.clearFileForPrivateSignPng()
		this.props.actions.setFilesWithDSForPrivateSign(null)
		this.props.actions.setImageForPrivateSign(null)
		this.props.actions.setConvertedImage(null)
		this.props.actions.setSignedDataForInputFile(null)
		this.props.actions.setSignaturePageNumder(1);
		this.props.actions.setSignaturePositionX(20);
		this.props.actions.setSignaturePositionY(20);
		this.props.actions.setSignatureSize(tempObj)
		this.props.actions.setImageParamsSetted(false);
	}

	createMobileDS() {
		var _this = this
		this.props.actions.clearFileListWithDS()
		this.props.actions.clearQRList();
		this.setState({"qrForFiles": []})
		this.setState({"filesWithDS": []})
		this.setState({"displayedData": null})
		this.setState({isLoading: true})
		this.props.actions.createSession(this.props.base.cloudURLForMobileDS, this.props.base.token)
        .then((response) => {
			this.setState({uuid: response.ticketUuid})
			console.log(response);
        })
        .then(async () => {
        	for (var i = 0; i < this.props.createDSDefaultState.fileList.length; i += 1) {
        		await this.sendFilesMobileDS(this.props.createDSDefaultState.fileList[i])
			}
        })
        .then(async () => {
        	for (var i = 0; i < this.state.filesWithDS.length; i += 1) {
        		await this.verifyFiles(this.state.filesWithDS[i], i)
			}
        })
		.then(() => this.setState({isLoading: false}))
		.then(() => this.props.actions.deleteSession(this.props.base.cloudURLForMobileDS, this.state.uuid, this.props.base.token))
		.then(() => this.props.actions.setFilesWithDS(this.state.filesWithDS))
		.then(() => this.props.actions.setQRList(this.state.qrForFiles))
		.then(() => {
			if (!_this.props.createDSDefaultState.active) {
				return
			}
			if (_this.state.failed > 0) {
				alert(i18next.t("ds:dsSuccessfullyCreated") + this.state.success + i18next.t("ds:dsFileFiles") + "\n" + i18next.t("ds:dsCreatingError") + this.state.failed + i18next.t("ds:dsFileFiles"))
			} else {
				// alert(i18next.t("ds:dsSuccessfullyCreated": "dsSuccessfullyCreated") + this.state.success + i18next.t("ds:dsFileFiles": "dsFileFiles"))
			}
		})
		.then(() => this.setState({"success": 0}, () => this.setState({"failed": 0})))
	}

	withToken() {
		var _this = this, url, token, errorMessage;

		if (this.props.pkLocalState.useUccConnection) {
			url = this.props.base.urlUCC + "/api/v1"
		} else {
			url = this.props.base.urlCloud + "/api/v1"
		}

		token = this.props.pkLocalState.useUccConnection === true ? null : this.props.base.token

		this.props.actions.clearFileListWithDS()
		this.props.actions.clearQRList();
		this.setState({"qrForFiles": []})
		this.setState({"filesWithDS": []})
		this.setState({"displayedData": null})
		this.setState({isLoading: true})
		this.setState({"successCreation": false})
		this.setState({"success": 0})
		this.props.actions.createSession(url, token)
        .then((response) => {
			this.setState({uuid: response.ticketUuid})
			console.log(response);
          	
        })
        .then(async () => {
        	if (this.props.defaultState.isPrivateSignature) {
        		await this.sendFilesWithToken(this.state.modifyedPdfData !== null ? this.state.modifyedPdfData : this.props.createDSDefaultState.fileForPrivateSign)
        	} else {
        		for (var i = 0; i < this.props.createDSDefaultState.fileList.length; i += 1) {
	        		await this.sendFilesWithToken(this.props.createDSDefaultState.fileList[i])
				}
        	}
        })
        .then(async () => {
        	if (this.props.defaultState.isPrivateSignature) {
	        	await this.verifyFiles(this.state.modifyedPdfData !== null ? this.state.modifyedPdfData : this.props.createDSDefaultState.fileForPrivateSign)
			} else {
				for (var i = 0; i < this.state.filesWithDS.length; i += 1) {
	        		await this.verifyFiles(this.state.filesWithDS[i], i)
				}
			}
        })
		.then(() => this.setState({isLoading: false}))
		.then(() => this.props.actions.deleteSession(url, this.state.uuid, token))
		.then(() => this.props.defaultState.isPrivateSignature ? this.props.actions.setFilesWithDSForPrivateSign(this.state.filesWithDS) : this.props.actions.setFilesWithDS(this.state.filesWithDS))
		.then(() => this.props.actions.setQRList(this.state.qrForFiles))
		.then(() => {
			if (!_this.props.createDSDefaultState.active) {
				return
			}
			if (_this.state.failed > 0) {
				if (_this.props.defaultState.isPrivateSignature) {
					if (_this.props.base.isVtco) {
						errorMessage = {
							message: _this.state.filesWithDS[0].message,
                      		techMessage: _this.state.filesWithDS[0].techMessage
						}
					} else {
						errorMessage = {
							message: _this.state.filesWithDS[0].message,
                      		techMessage: _this.state.filesWithDS[0].failureCause
						}
					}
					
				} else {
					errorMessage = {
						message: i18next.t("ds:dsSuccessfullyCreated") + this.state.success + i18next.t("ds:dsFileFiles") + "\n" + i18next.t("ds:dsCreatingError") + this.state.failed + i18next.t("ds:dsFileFiles")
	                }
				}
				
                _this.props.actions.setErrorData(errorMessage)
                _this.props.actions.setShowErrorPopup(true)

				// alert(i18next.t("ds:dsSuccessfullyCreated") + this.state.success + i18next.t("ds:dsFileFiles") + "\n" + i18next.t("ds:dsCreatingError") + this.state.failed + i18next.t("ds:dsFileFiles"))
			} else {

				if (!this.props.defaultState.isPrivateSignature) {
					_this.setState({"successCreation": true})
				}
				
				// alert(i18next.t("ds:dsSuccessfullyCreated": "dsSuccessfullyCreated") + this.state.success + i18next.t("ds:dsFileFiles": "dsFileFiles"))
			}
		})
		.then(() => this.setState({"failed": 0}))
		.then(() => this.props.actions.setTmpPin(""))
		.then(() => this.props.actions.setTmpTwoFactorCode(""))
	}

	selectVtcoSign () {
		var data, _this = this, errorMessage;
		this.setState({isLoading: true})

		if (this.props.pkLocalState.isTwoFactorEnable) {
			data = {
			    "ciHsmTokenUri": this.props.pkLocalState.vtcoSelectedKey.uri,
			    "operationType": "SIGNING",
			    "permissionTtlSeconds" : 10,
			    "permissionRepetition" : 2
			}

			this.props.actions.premission2fVtco(this.props.base.vtcoURL, data, this.props.pkLocalState.vtcoTokenBody)
		    .then((response) => {
		    	if ((response.processingType !== null && response.processingType !== undefined) && response.processingType === "V_TOKEN_PASS") {
                    this.props.actions.setInputTypeFor2F("image")
                    this.props.actions.setImageFor2F(response.processingData.qrCodePngData)
                    this.setState({codeTtl: response.codeTtl})
                    this.createVtcoSign2f();
                } else {
                    this.props.actions.setInputTypeFor2F("text")
                    this.props.actions.setImageFor2F(null)
                }

		    	if (response.code !== undefined) {
		    		_this.setState({isLoading: false})
		    		errorMessage = {
	                  message: response.message,
	                  techMessage: response.techMessage
	                }
	                _this.props.actions.setErrorData(errorMessage)
	                _this.props.actions.setShowErrorPopup(true)

		    		// var msg = response.message + "\n" + response.techMessage
		    		// alert(msg);
		    	}
		    })
			// this.createVtcoSign2f()
			this.setState({numberOfPinInput: this.props.base.numberOfPinInput - 1});
			this.setState({needToReEnterPin: true});
			this.setState({"showVtcoConfirmPopup": true})
		} else {
			this.createVtcoSign()
		}
	}

	createVTokenPassSign () {
		var counter = 0, resultDataArray = [], dataToSignIds = [], names = [], signatureFormat, resultDSDataArray = [], _this = this, sendData, insertData, errorMessage, jsonObject;
		this.controller = new AbortController();

		this.setState({isLoading: true})
		this.setState({"success": 0})

		if (this.props.defaultState.xadesType !== "NONE") {
			signatureFormat = this.props.defaultState.xadesType
		} else {
			if (this.props.defaultState.padesType !== "NONE") {
				signatureFormat = this.props.defaultState.padesType
			} else {
				signatureFormat = this.props.defaultState.cadesType
			}
		}

		sendData = function () {
			if ((_this.props.defaultState.cadesType === "CADES_BES" || _this.props.defaultState.cadesType === "CADES_X_LONG") && _this.props.defaultState.asicForm === "NONE") {
				jsonObject = {
					embedContentTs : true,
					signatureType : _this.props.defaultState["signatureType"].toUpperCase(),
					signatureFormat : signatureFormat,
					embedSignerCertificate : true,
					asicForm : _this.props.defaultState.asicForm,
					dataToSign : resultDataArray
			    }
			} else {
				if (_this.props.defaultState.isPrivateSignature) {
					jsonObject = {
						embedContentTs : true,
						signatureType : _this.props.defaultState["signatureType"].toUpperCase(),
						signatureFormat : signatureFormat,
						embedSignerCertificate : true,
						asicForm : _this.props.defaultState.asicForm,
						dataToSign : resultDataArray,
						dataToSignIdentifiers : dataToSignIds,
						padesCreationParameters: [
					        {
					            "signaturePositionX": _this.props.createDSDefaultState.signaturePositionX,
					            "signaturePositionY": _this.props.createDSDefaultState.signaturePositionY,
					            "signaturePageNumber": _this.props.createDSDefaultState.signaturePageNumber,
					            "signatureImageData": _this.props.createDSDefaultState.convertedImage,
					            "signatureImageHeight": _this.props.createDSDefaultState.qrAdvancedChecked ? 87 : _this.props.createDSDefaultState.signatureImageHeight,
								"signatureImageWidth": _this.props.createDSDefaultState.qrAdvancedChecked ? 293 : _this.props.createDSDefaultState.signatureImageWidth
					        }
					    ]
				    }
				} else {
 					jsonObject = {
						embedContentTs : true,
						signatureType : _this.props.defaultState["signatureType"].toUpperCase(),
						signatureFormat : signatureFormat,
						embedSignerCertificate : true,
						asicForm : _this.props.defaultState.asicForm,
						dataToSign : resultDataArray,
						dataToSignIdentifiers : dataToSignIds
				    }
				}

			}

			_this.props.actions.getVtcoProtectedParams(_this.props.base.vtcoURL, _this.props.base.authJwt)
	        .then((response) => {
	            if (response.code !== undefined) {
	                console.log(response);
	                errorMessage = {
	                  message: response.message,
	                  techMessage: response.techMessage
	                }
	                _this.props.actions.setErrorData(errorMessage)
	                _this.props.actions.setShowErrorPopup(true)
	                // alert(response.message + '\n' + response.techMessage)
	            } else {
	                _this.props.actions.setProtectedParams(response)
	                
	                console.log(response);
	                console.log(jsonObject);

	                var cipherResult = cipher(jsonObject, response.publicKeyTextual, response.currentUtcDateTime);

				    var data = {
				        "encryptedData": cipherResult.encryptedData,
				        "secretKey": cipherResult.secretKey
				    }

				    _this.props.actions.getVTokenMpo(_this.props.base.vtcoURL, _this.props.base.authJwt)
					.then((response) => {
						_this.setState({mpoTtlMillis: response.mpoTtlMillis / 1000})
			    		_this.props.actions.createVTokenES(_this.props.base.vtcoURL, response.mpoId, data, _this.props.base.authJwt)
			    		.then((response) => {
					    	if (response.code !== undefined) {
					    		_this.setState({isLoading: false})
					    		errorMessage = {
			                      message: response.message,
			                      techMessage: response.techMessage
			                    }
			                    _this.props.actions.setErrorData(errorMessage)
			                    _this.props.actions.setShowErrorPopup(true)
					    		// var msg = response.message + "\n" + response.techMessage
					    		// alert(msg);
					    	}

					    	console.log(response)

					    	var newQrImage = {
					    		version: response.version,
					    		mpoId: response.mpoId,
					    		vtokenUri: _this.props.base.vtcoURL
					    	}

					    	const imgForVTokenPass = JSON.stringify(newQrImage);
					    	_this.setState({base64ImgForVTokenPass: imgForVTokenPass})

							console.log(imgForVTokenPass);


					    	_this.setState({showVTokenPassConfirmPopup: true})

					    	_this.props.actions.getVTokenPassResult(_this.props.base.vtcoURL, response.mpoId, _this.props.base.authJwt, _this.controller.signal)
					    	.then((response) => {

					    		if (response === "canceled") {
									_this.setState({isLoading: false})
									_this.setState({"showVTokenPassConfirmPopup": false})
					                return;
					            }

						    	if (response.code !== undefined) {
						    		_this.setState({isLoading: false})
						    		_this.setState({"showVTokenPassConfirmPopup": false})
						    		errorMessage = {
				                      message: response.code === "CIHSMVTCOBASE-7" ? i18next.t("vTokenPassTimeOut") : response.message,
				                      techMessage: response.techMessage
				                    }
				                    _this.props.actions.setErrorData(errorMessage)
				                    _this.props.actions.setShowErrorPopup(true)
						    		// var msg = response.message + "\n" + response.techMessage
						    		// alert(msg);
						    	} else {
						    		insertData = function (index) {
						    			resultDSDataArray.push(response[index])
						    			_this.setState({"success": _this.state.success += 1})
						    		}

						    		_this.props.createDSDefaultState.fileList.forEach(function (file) {
							            names.forEach(function (name, index) {
							            	if (name === file.name) {
							            		insertData(index)
							            	}
							            })
							        })

							        if (_this.props.defaultState.isPrivateSignature) {
							        	_this.setState({"filesWithDS": resultDSDataArray});
								    	_this.props.actions.setFilesWithDSForPrivateSign(response)
								    	_this.setState({"showVTokenPassConfirmPopup": false})
								    	// _this.setState({successCreation: true})
								    	_this.setState({isLoading: false})
							        } else {
							        	_this.setState({"filesWithDS": resultDSDataArray});
								    	_this.props.actions.setFilesWithDS(resultDSDataArray)
								    	_this.setState({"showVTokenPassConfirmPopup": false})
								    	_this.setState({successCreation: true})
								    	_this.setState({isLoading: false})
							        }
						    	}
						    })
					    })
				    })
	            }
	        })

		    
		    
		}

		function readFile(file) {
		  return new Promise((resolve, reject) => {
		    const reader = new FileReader();

		    reader.onload = res => {
		    var base64String = window.btoa(res.target.result);
		    names.push(file.name)
		      resolve(base64String);
		    };
		    reader.onerror = err => reject(err);

		    reader.readAsBinaryString(file);
		  });
		}

    	async function read(file) {
			resultDataArray.push(await readFile(file));
			var UTF8 = {
			    encode: function(s){
			        for(var c, i = -1, l = (s = s.split("")).length, o = String.fromCharCode; ++i < l;
			            s[i] = (c = s[i].charCodeAt(0)) >= 127 ? o(0xc0 | (c >>> 6)) + o(0x80 | (c & 0x3f)) : s[i]
			        );
			        return s.join("");
			    },
			    decode: function(s){
			        for(var a, b, i = -1, l = (s = s.split("")).length, o = String.fromCharCode, c = "charCodeAt"; ++i < l;
			            ((a = s[i][c](0)) & 0x80) &&
			            (s[i] = (a & 0xfc) == 0xc0 && ((b = s[i + 1][c](0)) & 0xc0) == 0x80 ?
			            o(((a & 0x03) << 6) + (b & 0x3f)) : o(128), s[++i] = "")
			        );
			        return s.join("");
			    }
			};

			var newString = UTF8.encode(file.name);
			dataToSignIds.push(newString)

			counter += 1;

			if (_this.props.defaultState.isPrivateSignature) {
				sendData()
			}

            if (counter === _this.props.createDSDefaultState.fileList.length) {
            	sendData()
            }
		}

		if (this.props.defaultState.isPrivateSignature) {
			read(this.state.modifyedPdfData !== null ? this.state.modifyedPdfData : this.props.createDSDefaultState.fileForPrivateSign);
		} else {
			for (var i = 0; i < this.props.createDSDefaultState.fileList.length; i += 1) {
	            read(this.props.createDSDefaultState.fileList[i]);
			}
		}
	}

	closeVtcoConfirm (value) {
		if (value === true) {
			this.setState({"showVtcoConfirmPopup": false})
			return;
		} else {
			if (this.state.showVtcoConfirmPopup === true && this.state.needToReEnterPin === true) {
				if (this.state.numberOfPinInput > 0) {
					this.createVtcoSign2f()
				} else {
					this.setState({needToReEnterPin: false});
					this.setState({numberOfPinInput: 0});
					this.setState({isLoading: false});
				}
			}

			this.setState({"showVtcoConfirmPopup": false})
		}
	}

	createVtcoSign2f () {
		this.controller = new AbortController();
		var data, _this = this, errorMessage;
		this.setState({isLoading: true})

		data = {
		    "ciHsmTokenUri": _this.props.pkLocalState.vtcoSelectedKey.uri,
		    "operationType": "SIGNING",
		    "twoFactorCode" : _this.props.base.inputTypeFor2F === "image" ? "" : this.props.base.twoFactorCode
		}

		_this.props.actions.premissionVtco(this.props.base.vtcoURL, data, this.props.pkLocalState.vtcoTokenBody, this.controller.signal)
		.then((response) => {

			if (response === "canceled") {
				_this.setState({isLoading: false})
				_this.setState({"showVtcoConfirmPopup": false})
                return;
            }

	    	if (response.code !== undefined) {
	    		if (response.code === "AUTHCOMMON-14") {
            		var currentCount = _this.state.numberOfPinInput

            		if (currentCount === 0) {
            			currentCount = _this.props.base.numberOfPinInput - 1;
            		} else {
            			currentCount = currentCount - 1;
            		}

            		_this.setState({numberOfPinInput: currentCount});
					_this.setState({needToReEnterPin: true});
					_this.setState({showVtcoConfirmPopup: true})
            	} else {
            		_this.setState({isLoading: false})
            		errorMessage = {
                      message: response.message,
                      techMessage: response.techMessage
                    }
                    _this.props.actions.setErrorData(errorMessage)
                    _this.props.actions.setShowErrorPopup(true)

		    		// var msg = response.message + "\n" + response.techMessage
		    		// alert(msg);
            	}
	    	} else {
	    		_this.createVtcoSign();
	    	}
	    })
	}

	createVtcoSign () {
		var counter = 0, resultDataArray = [], dataToSignIds = [], names = [], signatureFormat, resultDSDataArray = [], _this = this, sendData, insertData, errorMessage, jsonObject;
		this.setState({isLoading: true})
		this.setState({"success": 0})

		if (this.props.defaultState.xadesType !== "NONE") {
			signatureFormat = this.props.defaultState.xadesType
		} else {
			if (this.props.defaultState.padesType !== "NONE") {
				signatureFormat = this.props.defaultState.padesType
			} else {
				signatureFormat = this.props.defaultState.cadesType
			}
		}

		sendData = function () {
			if ((_this.props.defaultState.cadesType === "CADES_BES" || _this.props.defaultState.cadesType === "CADES_X_LONG") && _this.props.defaultState.asicForm === "NONE") {
				jsonObject = {
		        	pin : _this.props.pkLocalState.vtcoPin,
					embedContentTs : true,
					signatureType : _this.props.defaultState["signatureType"].toUpperCase(),
					signatureFormat : signatureFormat,
					embedSignerCertificate : true,
					asicForm : _this.props.defaultState.asicForm,
					dataToSign : resultDataArray,
					hashAlgorithm : _this.props.defaultState.hashAlgorithm
			    }
			} else {
				if (_this.props.defaultState.isPrivateSignature) {
					jsonObject = {
			        	pin : _this.props.pkLocalState.vtcoPin,
						embedContentTs : true,
						signatureType : _this.props.defaultState["signatureType"].toUpperCase(),
						signatureFormat : signatureFormat,
						embedSignerCertificate : true,
						asicForm : _this.props.defaultState.asicForm,
						dataToSign : resultDataArray,
						dataToSignIdentifiers : dataToSignIds,
						hashAlgorithm : _this.props.defaultState.hashAlgorithm,
						padesCreationParameters: [
					        {
					            "signaturePositionX": _this.props.createDSDefaultState.signaturePositionX,
					            "signaturePositionY": _this.props.createDSDefaultState.signaturePositionY,
					            "signaturePageNumber": _this.props.createDSDefaultState.signaturePageNumber,
					            "signatureImageData": _this.props.createDSDefaultState.convertedImage,
					            "signatureImageHeight": _this.props.createDSDefaultState.qrAdvancedChecked ? 87 : _this.props.createDSDefaultState.signatureImageHeight,
								"signatureImageWidth": _this.props.createDSDefaultState.qrAdvancedChecked ? 293 : _this.props.createDSDefaultState.signatureImageWidth
					        }
					    ]
				    }
				} else {
 					jsonObject = {
			        	pin : _this.props.pkLocalState.vtcoPin,
						embedContentTs : true,
						signatureType : _this.props.defaultState["signatureType"].toUpperCase(),
						signatureFormat : signatureFormat,
						embedSignerCertificate : true,
						asicForm : _this.props.defaultState.asicForm,
						dataToSign : resultDataArray,
						dataToSignIdentifiers : dataToSignIds,
						hashAlgorithm : _this.props.defaultState.hashAlgorithm
				    }
				}

			}

		    var cipherResult = cipher(jsonObject, _this.props.pkLocalState.publicKeyTextual, _this.props.pkLocalState.currentUtcDateTime);

		    var data = {
		        "ciHsmTokenUri": _this.props.pkLocalState.vtcoSelectedKey.uri,
		        "encryptedData": cipherResult.encryptedData,
		        "secretKey": cipherResult.secretKey
		    }

		    _this.props.actions.createVtcoDs(_this.props.base.vtcoURL, data, _this.props.pkLocalState.vtcoTokenBody)
		    .then((response) => {
		    	if (response.code !== undefined) {
		    		_this.setState({isLoading: false})
		    		errorMessage = {
                      message: response.message,
                      techMessage: response.techMessage
                    }
                    _this.props.actions.setErrorData(errorMessage)
                    _this.props.actions.setShowErrorPopup(true)
		    		// var msg = response.message + "\n" + response.techMessage
		    		// alert(msg);
		    	} else {
		    		insertData = function (index) {
		    			resultDSDataArray.push(response[index])
		    			_this.setState({"success": _this.state.success += 1})
		    		}

		    		_this.props.createDSDefaultState.fileList.forEach(function (file) {
			            names.forEach(function (name, index) {
			            	if (name === file.name) {
			            		insertData(index)
			            	}
			            })
			        })

			        if (_this.props.defaultState.isPrivateSignature) {
			        	_this.setState({"filesWithDS": resultDSDataArray});
				    	_this.props.actions.setFilesWithDSForPrivateSign(response)
				    	_this.setState({"showVtcoConfirmPopup": false})
				    	// _this.setState({successCreation: true})
				    	_this.setState({isLoading: false})
			        } else {
			        	_this.setState({"filesWithDS": resultDSDataArray});
				    	_this.props.actions.setFilesWithDS(resultDSDataArray)
				    	_this.setState({"showVtcoConfirmPopup": false})
				    	_this.setState({successCreation: true})
				    	_this.setState({isLoading: false})
			        }
		    	}
		    })
		}

		function readFile(file) {
		  return new Promise((resolve, reject) => {
		    const reader = new FileReader();

		    reader.onload = res => {
		    var base64String = window.btoa(res.target.result);
		    names.push(file.name)
		      resolve(base64String);
		    };
		    reader.onerror = err => reject(err);

		    reader.readAsBinaryString(file);
		  });
		}

    	async function read(file) {
			resultDataArray.push(await readFile(file));
			var UTF8 = {
			    encode: function(s){
			        for(var c, i = -1, l = (s = s.split("")).length, o = String.fromCharCode; ++i < l;
			            s[i] = (c = s[i].charCodeAt(0)) >= 127 ? o(0xc0 | (c >>> 6)) + o(0x80 | (c & 0x3f)) : s[i]
			        );
			        return s.join("");
			    },
			    decode: function(s){
			        for(var a, b, i = -1, l = (s = s.split("")).length, o = String.fromCharCode, c = "charCodeAt"; ++i < l;
			            ((a = s[i][c](0)) & 0x80) &&
			            (s[i] = (a & 0xfc) == 0xc0 && ((b = s[i + 1][c](0)) & 0xc0) == 0x80 ?
			            o(((a & 0x03) << 6) + (b & 0x3f)) : o(128), s[++i] = "")
			        );
			        return s.join("");
			    }
			};

			var newString = UTF8.encode(file.name);
			dataToSignIds.push(newString)

			counter += 1;

			if (_this.props.defaultState.isPrivateSignature) {
				sendData()
			}

            if (counter === _this.props.createDSDefaultState.fileList.length) {
            	sendData()
            }
		}

		if (this.props.defaultState.isPrivateSignature) {
			read(this.state.modifyedPdfData !== null ? this.state.modifyedPdfData : this.props.createDSDefaultState.fileForPrivateSign);
		} else {
			for (var i = 0; i < this.props.createDSDefaultState.fileList.length; i += 1) {
	            read(this.props.createDSDefaultState.fileList[i]);
			}
		}
        
	}

	createMultipleDS() {
		var _this = this, url, errorMessage;
		let settedToken

		// if (this.props.createDSDefaultState.qrAdvancedChecked && this.state.qrTextDataSetted === false) {
		// 	this.addToPDFWithFont(this.state.qrTextData.qrText, this.state.qrTextData.base64Data, this.state.qrTextData.currentPage, this.state.qrTextData.imageX, this.state.qrTextData.imageY, this.state.qrTextData.imageWidth, this.state.qrTextData.imageHeight, this.state.qrTextData.scale)
		// 	return;
		// }

		if (this.props.base.isVtco) {
			this.selectVtcoSign();
			return;
		}

		if (this.props.base.isVTokenPass) {
			this.createVTokenPassSign();
			return;
		}

		if (this.props.pkLocalState.useUccConnection) {
			url = this.props.base.urlUCC + "/api/v1"
		} else {
			url = this.props.base.urlCloud + "/api/v1"
		}

		if (this.props.pkLocalState.tokenPathHSM.length > 0) {
			settedToken = {
				keyStoreUri: this.props.pkLocalState.tokenPathHSM
			}
		} else {
			if (this.props.pkLocalState.depositsignSelectedKey !== null) {
				settedToken = {
					keyStoreUri: this.props.pkLocalState.depositsignSelectedKey.KeyName
				}
			} else {
				settedToken = {
					keyStorePath: this.props.pkLocalState.activeToken ? this.props.pkLocalState.activeToken : this.props.pkLocalState.passiveToken
				}
			}
		}

		if (this.props.pkLocalState.mobileDSMode) {
			this.createMobileDS();
			return;
		}

		if (this.props.pkLocalState.keyContainer !== null) {
			if (this.props.connectionStatus.uccConnection && typeof this.props.pkLocalState.keyContainer === 'string') {
	            let keyPath = {"keyStorePath": this.props.pkLocalState.keyContainer}
	            this.setState({"settedToken": keyPath})
	            this.withToken()
	        } else {
	        	this.props.actions.clearFileListWithDS()
	        	this.props.actions.clearQRList();
	        	this.setState({"qrForFiles": []})
				this.setState({"filesWithDS": []})
				this.setState({"displayedData": null})
				this.setState({isLoading: true})
				this.setState({"successCreation": false})
				this.setState({"success": 0})
				this.props.actions.createSession(url, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token)
		        .then((response) => {
					this.setState({uuid: response.ticketUuid})
					console.log(response);
		          	
		        })
		        .then(async () => {
		        	if (this.props.defaultState.isPrivateSignature) {
		        		await this.sendFiles(this.state.modifyedPdfData !== null ? this.state.modifyedPdfData : this.props.createDSDefaultState.fileForPrivateSign)
		        	} else {
		        		for (var i = 0; i < this.props.createDSDefaultState.fileList.length; i += 1) {
			        		await this.sendFiles(this.props.createDSDefaultState.fileList[i])
						}
		        	}
		        	
		        })
		        .then(async () => {
		        	if (this.props.defaultState.isPrivateSignature) {
			        	await this.verifyFiles(this.state.modifyedPdfData !== null ? this.state.modifyedPdfData : this.props.createDSDefaultState.fileForPrivateSign)
					} else {
						for (var i = 0; i < this.state.filesWithDS.length; i += 1) {
			        		await this.verifyFiles(this.state.filesWithDS[i], i)
						}
					}
		        })
				.then(() => this.setState({isLoading: false}))
				.then(() => this.props.actions.deleteSession(url, this.state.uuid, _this.props.pkLocalState.useUccConnection ? null : _this.props.base.token))
				.then(() => this.props.defaultState.isPrivateSignature ? this.props.actions.setFilesWithDSForPrivateSign(this.state.filesWithDS) : this.props.actions.setFilesWithDS(this.state.filesWithDS))
				.then(() => this.props.actions.setQRList(this.state.qrForFiles))
				.then(() => {
					if (!_this.props.createDSDefaultState.active) {
						return
					}
					if (_this.state.failed > 0) {
						if (_this.props.defaultState.isPrivateSignature) {
							if (_this.props.base.isVtco) {
								errorMessage = {
									message: _this.state.filesWithDS[0].message,
		                      		techMessage: _this.state.filesWithDS[0].techMessage
								}
							} else {
								errorMessage = {
									message: _this.state.filesWithDS[0].message,
		                      		techMessage: _this.state.filesWithDS[0].failureCause
								}
							}
							
						} else {
							errorMessage = {
		                      message: i18next.t("ds:dsSuccessfullyCreated") + this.state.success + i18next.t("ds:dsFileFiles") + "\n" + i18next.t("ds:dsCreatingError") + this.state.failed + i18next.t("ds:dsFileFiles")
		                    }
		                }
	                    _this.props.actions.setErrorData(errorMessage)
	                    _this.props.actions.setShowErrorPopup(true)

						// alert(i18next.t("ds:dsSuccessfullyCreated") + this.state.success + i18next.t("ds:dsFileFiles") + "\n" + i18next.t("ds:dsCreatingError") + this.state.failed + i18next.t("ds:dsFileFiles"))
					} else {

						if (!this.props.defaultState.isPrivateSignature) {
							this.setState({"successCreation": true})
						}
						// this.setState({"successCreation": true})
						// alert(i18next.t("ds:dsSuccessfullyCreated": "dsSuccessfullyCreated") + this.state.success + i18next.t("ds:dsFileFiles": "dsFileFiles"))
					}
				})
				.then(() => this.setState({"failed": 0}))
				.then(() => this.props.actions.setTmpPin(""))
				.then(() => this.props.actions.setTmpTwoFactorCode(""))
	        }
	    } else {
	    	this.setState({"settedToken": settedToken})
	    	this.withToken()
	    }
	}

	createDS() {
		let settedToken
		this.setState({"success": 0})
		if (this.props.pkLocalState.tokenPathHSM.length > 0) {
			settedToken = {
				keyStoreUri: this.props.pkLocalState.tokenPathHSM
			}
		} else {
			settedToken = {
				keyStorePath: this.props.pkLocalState.activeToken ? this.props.pkLocalState.activeToken : this.props.pkLocalState.passiveToken
			}
		}

		if (this.props.pkLocalState.keyContainer !== null) {
			this.setState({isLoading: true})
			this.props.actions.createSession(this.props.connectionStatus.baseUrl)
	        .then((response) => {
	          this.setState({uuid: response.ticketUuid})
	          console.log(response);
	          return this.props.defaultState.duplicateSign && this.props.defaultState.signatureType === "attached"
	          		? this.props.actions.sendDSData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.createDSDefaultState.previsionDsFile)
		            .then(() => {
						return this.props.actions.sendSessionOption(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultState)
				            .then(() => this.props.actions.sendKeyContainer(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.pkLocalState.keyContainer))
				            .then(() => this.props.actions.createDS(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.pkLocalState.keyContainerPassword))
				            .then(() => this.props.actions.getDSResult(this.props.connectionStatus.baseUrl, this.state.uuid))
				            .then((response) => {
				            		if (response !== null) {
				            			this.props.actions.setDSData(response)
				                    	console.log(response)
				                    	this.setState({"successCreation": true})
				                    	// alert(i18next.t("ds:dsResponseSuccess": "dsResponseSuccess"))
				            		} else {
				            			alert(i18next.t("ds:dsResponseFailed"))
				            		}
				            		this.setState({isLoading: false})
				                  })
				            .then(() => this.props.actions.deleteSession(this.props.connectionStatus.baseUrl, this.state.uuid))
				            .then(() => this.props.createDSDefaultState.dsData ? this.getBlobData() : null)
					}) : this.props.defaultState.duplicateSign && this.props.defaultState.signatureType === "detached"
					? this.props.actions.sendInputData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.createDSDefaultState.fileForDS)
					.then(() => {
						return this.props.actions.sendDSData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.createDSDefaultState.previsionDsFile)
						.then(() => this.props.actions.sendSessionMetaData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.createDSDefaultState.fileForDSDescription)
			            .then(() => this.props.actions.sendSessionOption(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultState))
			            .then(() => this.props.actions.sendKeyContainer(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.pkLocalState.keyContainer))
			            .then(() => this.props.actions.createDS(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.pkLocalState.keyContainerPassword))
			            .then(() => this.props.actions.getDSResult(this.props.connectionStatus.baseUrl, this.state.uuid))
			            .then((response) => {
			            		if (response !== null) {
			            			this.props.actions.setDSData(response)
			                    	console.log(response)
			                    	this.setState({"successCreation": true})
			                    	// alert(i18next.t("ds:dsResponseSuccess": "dsResponseSuccess"))
			            		} else {
			            			alert(i18next.t("ds:dsResponseFailed"))
			            		}
			            		this.setState({isLoading: false})
			                  })
			            .then(() => this.props.actions.deleteSession(this.props.connectionStatus.baseUrl, this.state.uuid)))
			            .then(() => this.props.createDSDefaultState.dsData ? this.getBlobData() : null)
					}) : this.props.actions.sendInputData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.createDSDefaultState.fileForDS)
					.then(() => {
						return this.props.actions.sendSessionMetaData(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.createDSDefaultState.fileForDSDescription)
						.then(() => this.props.actions.sendSessionOption(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.defaultState))
			            .then(() => this.props.actions.sendKeyContainer(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.pkLocalState.keyContainer))
			            .then(() => this.props.actions.createDS(this.props.connectionStatus.baseUrl, this.state.uuid, this.props.pkLocalState.keyContainerPassword))
			            .then(() => this.props.actions.getDSResult(this.props.connectionStatus.baseUrl, this.state.uuid))
			            .then((response) => {
			            		if (response !== null) {
			            			this.props.actions.setDSData(response)
			                    	console.log(response)
			                    	this.setState({"successCreation": true})
			                    	// alert(i18next.t("ds:dsResponseSuccess": "dsResponseSuccess"))
			            		} else {
			            			alert(i18next.t("ds:dsResponseFailed"))
			            		}
			            		this.setState({isLoading: false})
			                  })
			            .then(() => this.props.actions.deleteSession(this.props.connectionStatus.baseUrl, this.state.uuid))
					})
	        })
		} else {
			this.withToken(settedToken)
		}
	}

    showPreviewPopup (id) {
		console.log(id)
		this.setState({"fileIndex": id})
		this.props.actions.setShowPreviewPopup(true);
	}

	getPrivateSign () {
		var blob;
		const b64toBlob = (b64Data, contentType, sliceSize=512) => {
		  const byteCharacters = atob(b64Data);
		  const byteArrays = [];

		  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		    const slice = byteCharacters.slice(offset, offset + sliceSize);

		    const byteNumbers = new Array(slice.length);
		    for (let i = 0; i < slice.length; i++) {
		      byteNumbers[i] = slice.charCodeAt(i);
		    }

		    const byteArray = new Uint8Array(byteNumbers);
		    byteArrays.push(byteArray);
		  }

		  const blob = new Blob(byteArrays, {type: contentType});
		  return blob;
		}

		if (this.props.base.isVtco || this.props.base.isVTokenPass) {
			var extensionType = {type : 'application/pdf'}
			blob = b64toBlob(this.props.createDSDefaultState.filesWithDSForPrivateSign[0], extensionType);
			saveAs(blob, this.props.createDSDefaultState.fileForPrivateSignName)
		} else {
			saveAs(this.props.createDSDefaultState.filesWithDSForPrivateSign[0], this.props.createDSDefaultState.fileForPrivateSignName)
		}
	}

    getBlobData(id) {
    	var blob, extension = ".p7s", extensionType = {type : 'application/pkcs7-signature'}, filename = "", fileWithoutExtension = "";
    	const b64toBlob = (b64Data, contentType, sliceSize=512) => {
		  const byteCharacters = atob(b64Data);
		  const byteArrays = [];

		  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		    const slice = byteCharacters.slice(offset, offset + sliceSize);

		    const byteNumbers = new Array(slice.length);
		    for (let i = 0; i < slice.length; i++) {
		      byteNumbers[i] = slice.charCodeAt(i);
		    }

		    const byteArray = new Uint8Array(byteNumbers);
		    byteArrays.push(byteArray);
		  }

		  const blob = new Blob(byteArrays, {type: contentType});
		  return blob;
		}

		if (this.props.defaultState.asicForm !== "NONE") {
			if (this.props.defaultState.asicForm === "ASIC_S") {
				extension = ".asics"
				extensionType = {type : 'application/vnd.etsi.asic-s+zip'}
			} else {
				extension = ".asice"
				extensionType = {type : 'application/vnd.etsi.asic-e+zip'}
			}
		}

		if (this.props.defaultState.xadesType !== "NONE") {
			if (this.props.defaultState.asicForm !== "NONE" && this.props.defaultState.asicForm === "ASIC_E") {
				extension = ".asice"
				extensionType = {type : 'application/vnd.etsi.asic-e+zip'}
			} else {
				extension = ".xml"
				extensionType = {type : 'application/xml'}
			}
		}

		if (this.props.defaultState.padesType !== "NONE") {
			extension = "-" + this.props.defaultState.padesType + ".pdf"
			extensionType = {type : 'application/pdf'}
		}

	    if (this.props.createDSDefaultState.fileList[id].name.length > 0) {

	    	if (this.props.defaultState.padesType !== "NONE") {
	    		filename = this.props.createDSDefaultState.fileList[id].name
	    		fileWithoutExtension = filename.split('.').slice(0, -1).join('.')
	    	}

	    	if (this.props.base.isVtco || this.props.base.isVTokenPass) {
	    		blob = b64toBlob(this.props.createDSDefaultState.filesWithDS[id], extensionType);

	    		if (fileWithoutExtension.length > 0) {
	    			saveAs(blob, fileWithoutExtension + extension)
	    		} else {
	    			saveAs(blob, this.props.createDSDefaultState.fileList[id].name + extension)
	    		}
	    		
	    	} else {
	    		saveAs(this.props.createDSDefaultState.filesWithDS[id], this.props.createDSDefaultState.fileList[id].name + extension)
	    	}
	    } else {

	    	if (this.props.defaultState.padesType !== "NONE") {
	    		filename = this.props.createDSDefaultState.previsionDsFileName
	    		fileWithoutExtension = filename.split('.').slice(0, -1).join('.')
	    	}

	    	if (this.props.base.isVtco || this.props.base.isVTokenPass) {
	    		blob = b64toBlob(this.props.createDSDefaultState.dsData, extensionType);

	    		if (fileWithoutExtension.length > 0) {
	    			saveAs(blob, fileWithoutExtension + extension)
	    		} else {
	    			saveAs(blob, this.props.createDSDefaultState.previsionDsFileName + extension)
	    		}
	    		
	    	} else {
	    		saveAs(this.props.createDSDefaultState.dsData, this.props.createDSDefaultState.previsionDsFileName)
	    	}
	    } 
	}

	render() {
		const isEnabled = this.props.createDSDefaultState.fileList.length > 0 && !this.state.isLoading
		const isEnabledPrivateSign = (this.props.createDSDefaultState.fileForPrivateSignSelected && this.props.createDSDefaultState.fileForPrivateSignPngSelected && !this.state.isLoading) || (this.props.createDSDefaultState.fileForPrivateSignSelected && this.props.createDSDefaultState.qrChecked && !this.state.isLoading) || (this.props.createDSDefaultState.fileForPrivateSignSelected && this.props.createDSDefaultState.qrAdvancedChecked && !this.state.isLoading)

		return (
			<div>
	            <div className="card">
					<div className="card-header" onClick={this.expandCreateDS.bind(this)} role="button">
						{
							this.props.expandedCardsReducer.createExpanded ? <i className="fa fa-chevron-down" aria-hidden="true" style={{"cursor": "pointer"}}></i>
							: <i className="fa fa-chevron-up" aria-hidden="true" style={{"cursor": "pointer"}}></i>
						}&nbsp;{this.props.defaultState.isPrivateSignature ? i18next.t("ds:privateSignature") : i18next.t("file")}
					</div>
					{
						this.props.defaultState.isPrivateSignature
						? <div className={this.state.collapseCreateDSShow}>
							<div className="form-group row" style={{marginBottom: "0px"}}>
								<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label no-left-right-padding">{i18next.t("ds:privateSignaturePdf")}</label>
									{
                                		this.props.createDSDefaultState.fileForPrivateSignSelected
                                		? <div className="input-group mb-3">
											<input type="text" className="form-control" value={this.props.createDSDefaultState.fileForPrivateSignName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileForPrivateSing.bind(this)} readOnly />
                                    		<div className="input-group-append">
										      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileForPrivateSign.bind(this)}>{i18next.t("cleanup")}</button>
										    </div>
										</div>
									    : <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{marginLeft: "0px", marginRight: "0px", paddingLeft: "0px", paddingRight: "0px"}}>
					                    	{
					                    		this.props.base.googleDriveEnabled === "true"
					                    		? <div className="row">
					                    			<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 padding-left-0-gdrive">
					                    				<Dropzone onDrop={this.handleOnDropPrivateSign} ref={dropzoneFileForPrivateSignRef} accept=".pdf" multiple={false}>
									                        {({getRootProps, getInputProps}) => (
									                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone col-lg-12 col-md-12 col-xs-12 col-sm-12" id="dropCert">
									                                <input {...getInputProps()} />
									                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
									                            </div>
									                        )}
									                    </Dropzone>
								                    </div>
								                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 no-left-padding-gdrive padding-left-0-gdrive">
														<GooglePicker caller={"fileForPrivateSing"} />
													</div>
					                    		</div>
					                    		: <Dropzone onDrop={this.handleOnDropPrivateSign} ref={dropzoneFileForPrivateSignRef} accept=".pdf" multiple={false}>
							                        {({getRootProps, getInputProps}) => (
							                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone" id="dropCert">
							                                <input {...getInputProps()} />
							                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
							                            </div>
							                        )}
							                    </Dropzone>
							                }
													
							            </div>
                                	}
                                	<input id="fileForPrivateSingUpload" type="file" onChange={this.onChangeFileForPrivateSing.bind(this)} style={{"display": "none"}} />

                                	<div className="row" style={{marginLeft: "0px", marginRight: "0px"}}>
	                                	<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12" style={{paddingLeft: "0px", paddingRight: "0px"}}>
	                                		<div className="radio ml-tool-panel" style={{marginLeft: "20px", marginTop: "10px"}}>
					                            <label title={i18next.t("ds:privateSignatureImagesTooltip")}>
					                                <input className="form-check-input" type="radio" checked={this.props.createDSDefaultState.pngChecked === true} onChange={this.checkPngHandler} />
					                                <span className="form-check-label">{i18next.t("ds:privateSignatureSelectImage")}</span>
					                            </label>
					                        </div>
										</div>
										{
											this.props.base.isVTokenPass
											? null
											: <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12" style={{marginLeft: "0px", marginRight: "0px"}}>
		                                		<div className="radio ml-tool-panel" style={{marginLeft: "5px", marginTop: "10px"}}>
						                            <label title={i18next.t("ds:privateSignatureQr")}>
						                                <input className="form-check-input" type="radio" checked={this.props.createDSDefaultState.qrChecked === true} onChange={this.checkQrHandler} />
						                                <span className="form-check-label">{i18next.t("ds:privateSignatureQr")}</span>
						                            </label>
						                        </div>
						                        <div className="radio ml-tool-panel" style={{marginLeft: "5px", marginTop: "10px"}}>
						                            <label title={i18next.t("ds:privateSignatureQrAdvanced")}>
						                                <input className="form-check-input" type="radio" checked={this.props.createDSDefaultState.qrAdvancedChecked === true} onChange={this.checkQrAdvancedHandler} />
						                                <span className="form-check-label">{i18next.t("ds:privateSignatureQrAdvanced")}</span>
						                            </label>
						                        </div>
											</div>
										}
										
									</div>

									<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{paddingLeft: "0px", paddingRight: "0px"}}>
										{
			                            	this.props.createDSDefaultState.pngChecked
			                            	? <div style={{marginBottom: "15px"}}>
			                            		{
			                            			this.props.createDSDefaultState.fileForPrivateSignPngSelected
			                                		? <div className="input-group mb-3">
														<input type="text" className="form-control" value={this.props.createDSDefaultState.fileForPrivateSignPngName} style={{"backgroundColor": "white", "cursor": "pointer"}} onClick={this.handleFileForPrivateSingPng.bind(this)} readOnly />
			                                    		<div className="input-group-append">
													      	<button className="input-group-text" style={{"cursor": "pointer"}} onClick={this.cleanUpFileForPrivateSignPng.bind(this)}>{i18next.t("cleanup")}</button>
													    </div>
													</div>
												    : <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{marginLeft: "0px", marginRight: "0px", paddingLeft: "0px", paddingRight: "0px"}}>
								                    	{
								                    		this.props.base.googleDriveEnabled === "true"
								                    		? <div className="row">
								                    			<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 padding-left-0-gdrive">
								                    				<Dropzone onDrop={this.handleOnDropPrivateSignPng} ref={dropzoneFileForPrivateSignPngRef} accept=".png .jpg, .jpeg, .jp2, .j2k, .png, .bmp, image/jpeg, image/jp2, image/png, image/bmp" multiple={false}>
												                        {({getRootProps, getInputProps}) => (
												                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone col-lg-12 col-md-12 col-xs-12 col-sm-12" id="dropCert">
												                                <input {...getInputProps()} />
												                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
												                            </div>
												                        )}
												                    </Dropzone>
											                    </div>
											                    <div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 no-left-padding-gdrive padding-left-0-gdrive">
																	<GooglePicker caller={"fileForPrivateSingPng"} />
																</div>
								                    		</div>
								                    		: <Dropzone onDrop={this.handleOnDropPrivateSignPng} ref={dropzoneFileForPrivateSignPngRef} accept=".png .jpg, .jpeg, .jp2, .j2k, .png, .bmp, image/jpeg, image/jp2, image/png, image/bmp" multiple={false}>
										                        {({getRootProps, getInputProps}) => (
										                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone">
										                                <input {...getInputProps()} />
										                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitleSecond")}</p>
										                            </div>
										                        )}
										                    </Dropzone>
										                }
																
										            </div>
			                            		}
														
								            </div>
			                            	: null
			                            }
			                            <input id="fileForPrivateSingPngUpload" type="file" onChange={this.onChangeFileForPrivateSingPng.bind(this)} style={{"display": "none"}} accept=".png" />
									</div>
									
									<div className="card" style={{marginBottom: "10px"}}>
										<div className="card-header">
	                                		<label style={{marginBottom: "0px"}}>{i18next.t("ds:privateSignatureParams")}</label>
	                                	</div>
	                                	<div className="form-group col-lg-12 col-md-12 col-xs-12 col-sm-12 row no-left-right-margin" style={{marginTop: "10px", paddingLeft: "0px", paddingRight: "0px"}}>
	                                		<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 no-left-right-margin no-left-no-right-padding">
	                                			<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-no-right-padding" style={{color: "#888"}}>
					                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("ds:privateSignatureСoordinatesX")}<span style={{float: "right"}}>{this.props.createDSDefaultState.signaturePositionX}</span></label>
					                                {/*<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

					                                	<input type="text" className="form-control" disabled={this.props.base.globalProcessing ? true : false} value={this.props.createDSReducer.signaturePositionX} onChange={this.onSignaturePositionXChanged.bind(this)} />
							                        </div>
							                    */}
							                    </div>
							                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-no-right-padding" style={{color: "#888"}}>
					                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("ds:privateSignatureСoordinatesY")}<span style={{float: "right"}}>{this.props.createDSDefaultState.signaturePositionY}</span></label>
					                                {/*<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

					                                	<input type="text" className="form-control" disabled={this.props.base.globalProcessing ? true : false} value={this.props.createDSReducer.signaturePositionY} onChange={this.onSignaturePositionYChanged.bind(this)} />

							                        </div>*/}
							                    </div>
	                                		</div>

	                                		<div className="col-lg-6 col-md-6 col-xs-12 col-sm-12 no-left-right-margin no-left-no-right-padding">
	                                			<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-no-right-padding" style={{color: "#888"}}>
					                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("ds:privateSignaturePageNum")}<span style={{float: "right"}}>{this.props.createDSDefaultState.signaturePageNumber}</span></label>
					                                {/*<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">

					                                	<input type="text" className="form-control" disabled={this.props.base.globalProcessing ? true : false} value={this.props.createDSReducer.signaturePageNumber} onChange={this.onSignaturePageNumberChanged.bind(this)} />

							                        </div>*/}
							                    </div>
							                    
							                    <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 no-left-no-right-padding" style={{color: "#888"}}>
					                    			<label className="col-lg-12 col-md-12 col-xs-12 col-sm-12 col-form-label">{i18next.t("ds:signatureImageSize")}<span style={{float: "right"}}>{this.props.createDSDefaultState.signatureImageHeight + " x " + this.props.createDSDefaultState.signatureImageWidth + " px"}</span></label>
							                    </div>
	                                		</div>
			                                
			                                {/*<div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 row">
												<div className="input-group col-5" style={{paddingRight: "0px"}}>
													<label className="col-form-label">{i18next.t("ds:privateSignaturePageNum")}&nbsp;</label>
													<input type="text" value={this.state.signaturePageNumber} onChange={this.onSignaturePageNumberChanged.bind(this)} className="form-control" style={{borderRadius: "0.25rem"}} />
												</div>
				                                <div className="input-group col-3" style={{paddingRight: "0px"}}>
				                                  	<label className="col-form-label">X:&nbsp;</label>
				                                    <input type="text" value={this.state.signaturePositionX} onChange={this.onSignaturePositionXChanged.bind(this)} className="form-control col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{borderRadius: "0.25rem"}} />
				                                </div>
				                                <div className="input-group col-3" style={{paddingRight: "0px"}}>
				                                    <label className="col-form-label">Y:&nbsp;</label>
				                                    <input type="text" value={this.state.signaturePositionY} onChange={this.onSignaturePositionYChanged.bind(this)} className="form-control col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{borderRadius: "0.25rem"}} />
				                                </div>
				                                <label style={{paddingLeft: "15px", paddingTop: "10px", marginBottom: "0px"}}>{i18next.t("ds:coordinatesTitle")}</label>
			                                </div>*/}

			                                {
						                    	this.props.createDSDefaultState.signedDataForInputFile && this.props.createDSDefaultState.convertedImage
						                    	?   <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12" style={{marginTop: "10px"}}>
						                    		
													  <button className="btn btn-default col-lg-12 col-md-12 col-xs-12 col-sm-12" onClick={this.handleShow}>{i18next.t("ds:pdfPreviewForPrivateSign")}</button>
													  {this.state.showModal ? (
													    <PDFPreviewer
													      base64Data={"data:application/pdf;base64," + this.props.createDSDefaultState.signedDataForInputFile}
													      imageForSign={this.props.createDSDefaultState.imageForPrivateSign}
													      onClose={this.handleClose}
													      onImageProcessed={this.setImageData}
													      resizableImage={this.props.createDSDefaultState.qrChecked || this.props.createDSDefaultState.qrAdvancedChecked ? false : true}
													      qrText={this.props.createDSDefaultState.qrAdvancedChecked
													      	? this.state.textForQr
													      	: null
													      }
													      imagePlacementParams={this.props.createDSDefaultState.imageParamsSetted ? 
													      	{
													      		x: this.props.createDSDefaultState.signaturePositionX,
													      		y: this.props.createDSDefaultState.signaturePositionY,
													      		width: this.props.createDSDefaultState.signatureImageWidth,
													      		height: this.props.createDSDefaultState.signatureImageHeight,
													      		page: this.props.createDSDefaultState.signaturePageNumber
													      	} : null}
													    />
													  ) : null}
													</div>
												: null
						                    }
			                            </div>
									</div>
								</div>
								
							</div>

							<div className="row">
								<div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
			                        <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={!isEnabledPrivateSign} onClick={this.createQrForPrivateSign}>{i18next.t("ds:createDs")}
			                        	{
			                              	this.state.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
			                                : null
			                            }
			                        </button>
		                        </div>
		                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-left-padding">
		                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} disabled={this.state.isLoading} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm")}</button>
		                        </div>
		                        
		                        
	                        </div>
	                        {
	                        	this.props.createDSDefaultState.filesWithDSForPrivateSign && this.props.createDSDefaultState.filesWithDSForPrivateSign[0].failureCause === undefined && !this.state.isLoading
	                        	? <div className="row">
									<div className="col-lg-12 col-md-12 col-sm-6 col-xs-12">
				                        <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.getPrivateSign}>{i18next.t("saveToLocal")}
				                        </button>
			                        </div>
		                        </div>
		                        : null
	                        }
						  </div>
						: <div className={this.state.collapseCreateDSShow}>
		                    <div className="form-group row" style={{marginBottom: "0px"}}>
					            <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12 order-1">
					            	<ul className="add-files" style={{border: "1px solid rgba(0, 0, 0, 0.125)", borderRadius: "0.25rem", "listStyle": "none", "padding": "0", "minHeight": "200px"}}>
					            		{
					            			this.props.createDSDefaultState.fileList.map((n, index) => {
					            				var active = index % 2 === 0 ? "evenClassName" : "oddClassName"
											    return (<li key={index} className={active} style={{"padding": "5px"}}>
											    	{
											    		this.props.defaultState.generateQR
											    		? <span className="row">
												    		<span className={(this.state.isLoading || this.state.filesWithDS[index]) ? "col-md-8 col-sm-8 col-xs-8" : "col-md-9  col-sm-9 col-xs-9"} style={{"wordWrap": "break-word", "display": "block"}}>{n.name}</span>
												    		<span className="col-md-1 col-sm-1 col-xs-1" onClick={this.deleteItem.bind(this, index)}><i className="fa fa-trash" title={i18next.t("deleteTitle")} style={{"cursor": "pointer"}} aria-hidden="true"></i></span>
													    	<span className="col-md-1 col-sm-1 col-xs-1">
													    	{
													    		(this.state.filesWithDS[index] !== undefined && this.state.filesWithDS[index].failureCause)
													    			? <i className="fa fa-exclamation-triangle" title={i18next.t("errorTitle")} style={{"cursor": "pointer"}} onClick={this.showError.bind(this, index)}></i>
													    			: this.state.filesWithDS[index]
													    			? <i className="fa fa-download" title={i18next.t("saveTitle")} style={{"cursor": "pointer"}} onClick={this.getBlobData.bind(this, index)}></i>
													    			: null
													    	}
													    	{
													    		this.state.isLoading && !this.state.filesWithDS[index]
													    			? <i className="fa fa-spinner fa-pulse"></i>
													    			: null
													    	}
													    	</span>
													    	<span className="col-md-1 col-sm-1 col-xs-1" onClick={this.handleShowQR.bind(this, index)}>
													    	{
													    		this.state.qrForFiles[index]
													    			? <i className="fa fa-qrcode" style={{"cursor": "pointer"}} aria-hidden="true"></i>
													    			: null
													    	}
													    	</span>
													    </span>
													    : <span className="row">
												    		<span className={(this.state.isLoading || this.state.filesWithDS[index]) ? "col-md-9 col-sm-9 col-xs-9" : "col-md-10  col-sm-10 col-xs-10"} style={{"wordWrap": "break-word", "display": "block"}}>{n.name}</span>
												    		<span className="col-md-1 col-sm-1 col-xs-1" onClick={this.deleteItem.bind(this, index)}><i className="fa fa-trash" title={i18next.t("deleteTitle")} style={{"cursor": "pointer"}} aria-hidden="true"></i></span>
													    	<span className="col-md-1 col-sm-1 col-xs-1">
													    	{
													    		(this.state.filesWithDS[index] !== undefined && this.state.filesWithDS[index].failureCause)
													    			? <i className="fa fa-exclamation-triangle" title={i18next.t("errorTitle")} style={{"cursor": "pointer"}} onClick={this.showError.bind(this, index)}></i>
													    			: this.state.filesWithDS[index]
													    			? <i className="fa fa-download" title={i18next.t("saveTitle")} style={{"cursor": "pointer"}} onClick={this.getBlobData.bind(this, index)}></i>
													    			: null
													    	}
													    	{
													    		this.state.isLoading && !this.state.filesWithDS[index]
													    			? <i className="fa fa-spinner fa-pulse"></i>
													    			: null
													    	}
													    	</span>
													    </span>
											    	}
											    	
											    	
											    	</li>)
											})
					            		}
					            	</ul>
					            </div>
					            <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 no-left-padding order-0 order-lg-12" style={{"marginBottom": "10px"}}>

					            	{
					            		this.props.mobileModeReducer.isMobileDevice
					            		? <button className="btn btn-default btn-block" disabled={this.state.isLoading} onClick={this.handleFileInput.bind(this)}>{i18next.t("dsAddFileFilesTitle")}</button>
					            		: <Dropzone ref={dropzoneRef} onDrop={this.handleOnDrop}>
					                        {({getRootProps, getInputProps}) => (
					                            <div {...getRootProps()} style={{cursor: "pointer"}} className="dropzone-md" id="dropFile">
					                                <input {...getInputProps()} />
					                                <p style={{cursor: "pointer", marginTop: "16px"}}>{i18next.t("dragNDropTitle")}</p>
					                            </div>
					                        )}
					                    </Dropzone>
					            	}

					            </div>
					            <input id="filesMultipleUpload" type="file" onChange={this.onChangeFile.bind(this)} style={{"display": "none"}} multiple />
				            </div>
				            {
				            	this.state.successCreation
				            	? <div className="row col-12 success-action" style={{marginLeft: "0px", marginRight: "0px", marginBottom: "15px"}}>
					            	<label style={{marginBottom: "5px", marginTop: "5px"}}>{i18next.t("dsSuccess")}</label>
					              </div>
					            : null
				            }
				            
				            <div className="row">
								<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
			                        <button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.createMultipleDSWithSigns.bind(this)} disabled={!isEnabled}>{i18next.t("ds:createDs")}
			                        	{
			                              	this.state.isLoading ? <span>&nbsp;<i className="fa fa-spinner fa-pulse"></i></span>
			                                : null
			                            }
			                        </button>
		                        </div>
		                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 no-left-padding">
		                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" disabled={this.state.isLoading} onClick={this.cleanUpForm.bind(this)}>{i18next.t("cleanUpForm")}</button>
		                        </div>
		                        {
		                        	this.props.base.zipDownloadEnabled === "true" && this.props.createDSDefaultState.filesWithDS.length > 0 && !this.state.isLoading
		                        	? <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12" style={{paddingLeft: "0px"}}>
			                        	<button className="btn btn-default col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginBottom: "10px"}} onClick={this.downloadZip}>{i18next.t("downloadZipTitle")}</button>
			                        </div>
			                        : null
		                        }
	                        </div>

	                        {
	                        	this.props.defaultState.cleanUpForm
	                        	? this.cleanUpForm()
	                        	: null
	                        }
	                    </div>
					}
	              	
                </div>
                {
                	this.props.defaultState.isPrivateSignature
                	? null
                	: <CreateTextDSContainer />
                }
                <div>
                    {
                        this.state.showPopup
                        ? <QRPopup closeQRPopup={this.handleShowQR} data={this.state.displayedData} />
                        : null
                    }
                </div>
                <div>
                    {
                        this.state.showPinPopup
                        ? <PinPopup closePinPopup={this.handleShowPin} createDSUsingPin={this.handleCreateDSUsingPin} />
                        : null
                    }
                </div>
                {
					this.state.showVtcoConfirmPopup
					? <TwoFactorConfirmPopup initAction={this.closeVtcoConfirm.bind(this)} codeTtl={this.state.codeTtl} cancelRequest={this.cancelRequest} title={"createDsConfirm"} />
					: null
				}
				{
					this.state.showVTokenPassConfirmPopup
					? <VTokenPassConfirmPopup image={this.state.base64ImgForVTokenPass} mpoTtlMillis={this.state.mpoTtlMillis} cancelRequest={this.cancelRequest} title={"createVtokenPassDSTitle"} />
					: null
				}
            </div>
      )
	}
}


function mapStateToProps(state) {
    return {
    	language: state.localesReducer.language,
        localesReducer: state.localesReducer,
        pkLocalState: state.privateKeyReducer,
        defaultState: state.createDSOptionsReducer,
        createDSDefaultState: state.createDSInputReducer,
        connectionStatus: state.connectionStatusReucer,
        verifyDefaultState: state.verifyDSOptionsReducer,
        base: state.base,
        expandedCardsReducer: state.expandedCardsReducer,
        mobileModeReducer: state.mobileModeReducer,
        certInfoSignature: state.certificateInfo.certInfoSignature
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    languageSwitchItem,
		createSession,
		sendInputData,
		sendSessionMetaData,
		sendSessionOption,
		sendKeyContainer,
		createDS, getQR,
		getDSResult,
		deleteSession,
		setInputFileForDS,
		setInputDescription,
		clearInputFileForDS,
		clearInputDescription,
		setDSData,
		clearDSData,
		sendDSData,
		setPrevisionDsFile,
		clearPrevisionDsFile,
		sendTokenPath,
		setDSEncodingType,
		setFilesForDS,
		setFilesWithDS,
		clearFileList,
		clearFileListWithDS,
		getDSStatus,
		setCreateDSExpand,
		createMobileDS, getMobileDSData,
		getCreateMobileDSResult,
		verifyDSData, getVerifiedData,
		setQRList, clearQRList,
		setCleanUpForm,
		setTmpPin, setTmpTwoFactorCode,
		createVtcoDs, cipher,
		premission2fVtco, premissionVtco,
		setErrorData, setShowErrorPopup, getVTokenMpo,
		createVTokenES, getVTokenPassResult, getVtcoProtectedParams,
		setShowPreviewPopup, clearFileForPrivateSign, setFileForPrivateSign, setPngChecked, setQrChecked,
		setFileForPrivateSignPng, clearFileForPrivateSignPng, setFilesWithDSForPrivateSign,
		setImageForPrivateSign, setConvertedImage, setImageParamsSetted, setSignedDataForInputFile, setSignaturePageNumder, setSignaturePositionX,
		setSignaturePositionY, setSignatureSize, setQrAdvancedChecked, setQrTextData, setInputTypeFor2F, setImageFor2F, setProtectedParams
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateDSFilesContainer);